// I AM AUTO-GENERATED, DON'T CHECK ME INTO SUBVERSION (or else...)

import {ProtocolObject, ByteArray, ObjectFactory} from "./styx-api";


export class PlayerAction implements ProtocolObject {
    static CLASSID : number =  1;

    classId() {

        return PlayerAction.CLASSID;
    }
    public type : ActionType = 0;
    public minAmount : string;
    public maxAmount : string;
    public payload : number[];

    constructor(type? : ActionType, minAmount? : string, maxAmount? : string, payload? : number[]) {
        this.type = type;
        this.minAmount = minAmount;
        this.maxAmount = maxAmount;
        this.payload = payload;
    }

    public save(ba : ByteArray) :  void {
        if (typeof(this.type) == "undefined") {
            ba.writeUnsignedByte(-1);
        } else {
            ba.writeUnsignedByte(this.type);
        }
        ba.writeString(this.minAmount);
        ba.writeString(this.maxAmount);
        ba.writeInt(this.payload.length);
        for(let i = 0; i != this.payload.length; ++i) {
            ba.writeUnsignedByte(this.payload[i]);
        }
    }

    public load(ba : ByteArray) : void {
        this.type = ba.readUnsignedByte();
        this.minAmount = ba.readString();
        this.maxAmount = ba.readString();
        let a = ba.readInt();
        this.payload = ba.readArray(a);
    }
}
export class ErrorPacket implements ProtocolObject {
    static CLASSID : number =  4;

    classId() {

        return ErrorPacket.CLASSID;
    }
    public code : ErrorCode = 0;
    public referenceId : string;

    constructor(code? : ErrorCode, referenceId? : string) {
        this.code = code;
        this.referenceId = referenceId;
    }

    public save(ba : ByteArray) :  void {
        if (typeof(this.code) == "undefined") {
            ba.writeUnsignedByte(-1);
        } else {
            ba.writeUnsignedByte(this.code);
        }
        ba.writeString(this.referenceId);
    }

    public load(ba : ByteArray) : void {
        this.code = ba.readUnsignedByte();
        this.referenceId = ba.readString();
    }
}
export class FuturePlayerAction implements ProtocolObject {
    static CLASSID : number =  5;

    classId() {

        return FuturePlayerAction.CLASSID;
    }
    public action : ActionType = 0;

    constructor(action? : ActionType) {
        this.action = action;
    }

    public save(ba : ByteArray) :  void {
        if (typeof(this.action) == "undefined") {
            ba.writeUnsignedByte(-1);
        } else {
            ba.writeUnsignedByte(this.action);
        }
    }

    public load(ba : ByteArray) : void {
        this.action = ba.readUnsignedByte();
    }
}
export class GameState implements ProtocolObject {
    static CLASSID : number =  6;

    classId() {

        return GameState.CLASSID;
    }
    public name : string;
    public capacity : number;
    public tournamentId : number;
    public handInfo : HandStartInfo;
    public currentLevel : BlindsLevel;
    public secondsToNextLevel : number;
    public betStrategy : BetStrategy = 0;
    public currency : Currency;
    public variant : Variant = 0;
    public tags : string;
    public pauseEnabled : boolean;
    public paused : boolean;
    public buyIn : string;
    public jsngPrize : string;
    public jsngPrizeLevel : number;
    public jsngPrizeDistribution : string[];
    public jsngBuyInCurrencyCode : string;
    public mysteryBountyState : MysteryBountyState;
    public parentId : string;
    public isJsng : boolean;
    public isShovefest : boolean;
    public isShootout : boolean;
    public hasMysteryBounty : boolean;
    public hasBounty : boolean;
    public timedTournamentDurationMinutes : number;
    public attributes : ProtocolAttribute[];

    constructor(name? : string, capacity? : number, tournamentId? : number, handInfo? : HandStartInfo, currentLevel? : BlindsLevel, secondsToNextLevel? : number, betStrategy? : BetStrategy, currency? : Currency, variant? : Variant, tags? : string, pauseEnabled? : boolean, paused? : boolean, buyIn? : string, jsngPrize? : string, jsngPrizeLevel? : number, jsngPrizeDistribution? : string[], jsngBuyInCurrencyCode? : string, mysteryBountyState? : MysteryBountyState, parentId? : string, isJsng? : boolean, isShovefest? : boolean, isShootout? : boolean, hasMysteryBounty? : boolean, hasBounty? : boolean, timedTournamentDurationMinutes? : number, attributes? : ProtocolAttribute[]) {
        this.name = name;
        this.capacity = capacity;
        this.tournamentId = tournamentId;
        this.handInfo = handInfo;
        this.currentLevel = currentLevel;
        this.secondsToNextLevel = secondsToNextLevel;
        this.betStrategy = betStrategy;
        this.currency = currency;
        this.variant = variant;
        this.tags = tags;
        this.pauseEnabled = pauseEnabled;
        this.paused = paused;
        this.buyIn = buyIn;
        this.jsngPrize = jsngPrize;
        this.jsngPrizeLevel = jsngPrizeLevel;
        this.jsngPrizeDistribution = jsngPrizeDistribution;
        this.jsngBuyInCurrencyCode = jsngBuyInCurrencyCode;
        this.mysteryBountyState = mysteryBountyState;
        this.parentId = parentId;
        this.isJsng = isJsng;
        this.isShovefest = isShovefest;
        this.isShootout = isShootout;
        this.hasMysteryBounty = hasMysteryBounty;
        this.hasBounty = hasBounty;
        this.timedTournamentDurationMinutes = timedTournamentDurationMinutes;
        this.attributes = attributes;
    }

    public save(ba : ByteArray) :  void {
        ba.writeString(this.name);
        ba.writeInt(this.capacity);
        ba.writeInt(this.tournamentId);
        this.handInfo.save(ba);
        this.currentLevel.save(ba);
        ba.writeInt(this.secondsToNextLevel);
        if (typeof(this.betStrategy) == "undefined") {
            ba.writeUnsignedByte(-1);
        } else {
            ba.writeUnsignedByte(this.betStrategy);
        }
        this.currency.save(ba);
        if (typeof(this.variant) == "undefined") {
            ba.writeUnsignedByte(-1);
        } else {
            ba.writeUnsignedByte(this.variant);
        }
        ba.writeString(this.tags);
        ba.writeBoolean(this.pauseEnabled);
        ba.writeBoolean(this.paused);
        ba.writeString(this.buyIn);
        ba.writeString(this.jsngPrize);
        ba.writeInt(this.jsngPrizeLevel);
        if (!this.jsngPrizeDistribution) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.jsngPrizeDistribution.length);
            for(let i = 0; i != this.jsngPrizeDistribution.length; ++i)
                ba.writeString(this.jsngPrizeDistribution[i]);
        }
        ba.writeString(this.jsngBuyInCurrencyCode);
        this.mysteryBountyState.save(ba);
        ba.writeString(this.parentId);
        ba.writeBoolean(this.isJsng);
        ba.writeBoolean(this.isShovefest);
        ba.writeBoolean(this.isShootout);
        ba.writeBoolean(this.hasMysteryBounty);
        ba.writeBoolean(this.hasBounty);
        ba.writeInt(this.timedTournamentDurationMinutes);
        if (!this.attributes) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.attributes.length);
            for(let i = 0; i != this.attributes.length; ++i)
                this.attributes[i].save(ba);
        }
    }

    public load(ba : ByteArray) : void {
        this.name = ba.readString();
        this.capacity = ba.readInt();
        this.tournamentId = ba.readInt();
        this.handInfo = new HandStartInfo();
        this.handInfo.load(ba);
        this.currentLevel = new BlindsLevel();
        this.currentLevel.load(ba);
        this.secondsToNextLevel = ba.readInt();
        this.betStrategy = ba.readUnsignedByte();
        this.currency = new Currency();
        this.currency.load(ba);
        this.variant = ba.readUnsignedByte();
        this.tags = ba.readString();
        this.pauseEnabled = ba.readBoolean();
        this.paused = ba.readBoolean();
        this.buyIn = ba.readString();
        this.jsngPrize = ba.readString();
        this.jsngPrizeLevel = ba.readInt();
        let jsngPrizeDistributionCount : number = ba.readInt();
        this.jsngPrizeDistribution = [];
        for (let i = 0; i < jsngPrizeDistributionCount; i ++) {
            this.jsngPrizeDistribution.push(ba.readString());
        }
        this.jsngBuyInCurrencyCode = ba.readString();
        this.mysteryBountyState = new MysteryBountyState();
        this.mysteryBountyState.load(ba);
        this.parentId = ba.readString();
        this.isJsng = ba.readBoolean();
        this.isShovefest = ba.readBoolean();
        this.isShootout = ba.readBoolean();
        this.hasMysteryBounty = ba.readBoolean();
        this.hasBounty = ba.readBoolean();
        this.timedTournamentDurationMinutes = ba.readInt();
        let attributesCount : number = ba.readInt();
        this.attributes = [];
        for(let i = 0; i != attributesCount; ++i) {
            let _tmp : ProtocolAttribute = new ProtocolAttribute();
            _tmp.load(ba);
            this.attributes.push(_tmp);
        }
    }
}
export class ProtocolAttribute implements ProtocolObject {
    static CLASSID : number =  7;

    classId() {

        return ProtocolAttribute.CLASSID;
    }
    public name : string;
    public value : string;

    constructor(name? : string, value? : string) {
        this.name = name;
        this.value = value;
    }

    public save(ba : ByteArray) :  void {
        ba.writeString(this.name);
        ba.writeString(this.value);
    }

    public load(ba : ByteArray) : void {
        this.name = ba.readString();
        this.value = ba.readString();
    }
}
export class GameCard implements ProtocolObject {
    static CLASSID : number =  8;

    classId() {

        return GameCard.CLASSID;
    }
    public cardId : number;
    public suit : Suit = 0;
    public rank : Rank = 0;

    constructor(cardId? : number, suit? : Suit, rank? : Rank) {
        this.cardId = cardId;
        this.suit = suit;
        this.rank = rank;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.cardId);
        if (typeof(this.suit) == "undefined") {
            ba.writeUnsignedByte(-1);
        } else {
            ba.writeUnsignedByte(this.suit);
        }
        if (typeof(this.rank) == "undefined") {
            ba.writeUnsignedByte(-1);
        } else {
            ba.writeUnsignedByte(this.rank);
        }
    }

    public load(ba : ByteArray) : void {
        this.cardId = ba.readInt();
        this.suit = ba.readUnsignedByte();
        this.rank = ba.readUnsignedByte();
    }
}
export class BestHand implements ProtocolObject {
    static CLASSID : number =  9;

    classId() {

        return BestHand.CLASSID;
    }
    public player : number;
    public handType : HandType = 0;
    public cards : GameCard[];
    public attributes : BestHandAttribute[];
    public handId : number;

    constructor(player? : number, handType? : HandType, cards? : GameCard[], attributes? : BestHandAttribute[], handId? : number) {
        this.player = player;
        this.handType = handType;
        this.cards = cards;
        this.attributes = attributes;
        this.handId = handId;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.player);
        if (typeof(this.handType) == "undefined") {
            ba.writeUnsignedByte(-1);
        } else {
            ba.writeUnsignedByte(this.handType);
        }
        if (!this.cards) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.cards.length);
            for(let i = 0; i != this.cards.length; ++i)
                this.cards[i].save(ba);
        }
        if (!this.attributes) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.attributes.length);
            for(let i = 0; i != this.attributes.length; ++i)
                this.attributes[i].save(ba);
        }
        ba.writeInt(this.handId);
    }

    public load(ba : ByteArray) : void {
        this.player = ba.readInt();
        this.handType = ba.readUnsignedByte();
        let cardsCount : number = ba.readInt();
        this.cards = [];
        for(let i = 0; i != cardsCount; ++i) {
            let _tmp : GameCard = new GameCard();
            _tmp.load(ba);
            this.cards.push(_tmp);
        }
        let attributesCount : number = ba.readInt();
        this.attributes = [];
        for(let i = 0; i != attributesCount; ++i) {
            let _tmp : BestHandAttribute = new BestHandAttribute();
            _tmp.load(ba);
            this.attributes.push(_tmp);
        }
        this.handId = ba.readInt();
    }
}
export class BestHandAttribute implements ProtocolObject {
    static CLASSID : number =  10;

    classId() {

        return BestHandAttribute.CLASSID;
    }
    public key : string;
    public value : string;

    constructor(key? : string, value? : string) {
        this.key = key;
        this.value = value;
    }

    public save(ba : ByteArray) :  void {
        ba.writeString(this.key);
        ba.writeString(this.value);
    }

    public load(ba : ByteArray) : void {
        this.key = ba.readString();
        this.value = ba.readString();
    }
}
export class PlayerState implements ProtocolObject {
    static CLASSID : number =  11;

    classId() {

        return PlayerState.CLASSID;
    }
    public player : number;
    public cards : GameCard[];
    public balance : string;

    constructor(player? : number, cards? : GameCard[], balance? : string) {
        this.player = player;
        this.cards = cards;
        this.balance = balance;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.player);
        if (!this.cards) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.cards.length);
            for(let i = 0; i != this.cards.length; ++i)
                this.cards[i].save(ba);
        }
        ba.writeString(this.balance);
    }

    public load(ba : ByteArray) : void {
        this.player = ba.readInt();
        let cardsCount : number = ba.readInt();
        this.cards = [];
        for(let i = 0; i != cardsCount; ++i) {
            let _tmp : GameCard = new GameCard();
            _tmp.load(ba);
            this.cards.push(_tmp);
        }
        this.balance = ba.readString();
    }
}
export class CardToDeal implements ProtocolObject {
    static CLASSID : number =  12;

    classId() {

        return CardToDeal.CLASSID;
    }
    public player : number;
    public card : GameCard;

    constructor(player? : number, card? : GameCard) {
        this.player = player;
        this.card = card;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.player);
        this.card.save(ba);
    }

    public load(ba : ByteArray) : void {
        this.player = ba.readInt();
        this.card = new GameCard();
        this.card.load(ba);
    }
}
export class RequestAction implements ProtocolObject {
    static CLASSID : number =  13;

    classId() {

        return RequestAction.CLASSID;
    }
    public currentPotSize : string;
    public currentBetStack : string;
    public seq : number;
    public player : number;
    public allowedActions : PlayerAction[];
    public timeToAct : number;
    public handId : number;
    public chessClock : boolean;
    public chessClockInitialDelay : number;

    constructor(currentPotSize? : string, currentBetStack? : string, seq? : number, player? : number, allowedActions? : PlayerAction[], timeToAct? : number, handId? : number, chessClock? : boolean, chessClockInitialDelay? : number) {
        this.currentPotSize = currentPotSize;
        this.currentBetStack = currentBetStack;
        this.seq = seq;
        this.player = player;
        this.allowedActions = allowedActions;
        this.timeToAct = timeToAct;
        this.handId = handId;
        this.chessClock = chessClock;
        this.chessClockInitialDelay = chessClockInitialDelay;
    }

    public save(ba : ByteArray) :  void {
        ba.writeString(this.currentPotSize);
        ba.writeString(this.currentBetStack);
        ba.writeInt(this.seq);
        ba.writeInt(this.player);
        if (!this.allowedActions) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.allowedActions.length);
            for(let i = 0; i != this.allowedActions.length; ++i)
                this.allowedActions[i].save(ba);
        }
        ba.writeInt(this.timeToAct);
        ba.writeInt(this.handId);
        ba.writeBoolean(this.chessClock);
        ba.writeInt(this.chessClockInitialDelay);
    }

    public load(ba : ByteArray) : void {
        this.currentPotSize = ba.readString();
        this.currentBetStack = ba.readString();
        this.seq = ba.readInt();
        this.player = ba.readInt();
        let allowedActionsCount : number = ba.readInt();
        this.allowedActions = [];
        for(let i = 0; i != allowedActionsCount; ++i) {
            let _tmp : PlayerAction = new PlayerAction();
            _tmp.load(ba);
            this.allowedActions.push(_tmp);
        }
        this.timeToAct = ba.readInt();
        this.handId = ba.readInt();
        this.chessClock = ba.readBoolean();
        this.chessClockInitialDelay = ba.readInt();
    }
}
export class CardMoved implements ProtocolObject {
    static CLASSID : number =  14;

    classId() {

        return CardMoved.CLASSID;
    }
    public cardId : number;
    public playerId : number;
    public fromHand : number;
    public toHand : number;

    constructor(cardId? : number, playerId? : number, fromHand? : number, toHand? : number) {
        this.cardId = cardId;
        this.playerId = playerId;
        this.fromHand = fromHand;
        this.toHand = toHand;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.cardId);
        ba.writeInt(this.playerId);
        ba.writeInt(this.fromHand);
        ba.writeInt(this.toHand);
    }

    public load(ba : ByteArray) : void {
        this.cardId = ba.readInt();
        this.playerId = ba.readInt();
        this.fromHand = ba.readInt();
        this.toHand = ba.readInt();
    }
}
export class InformFutureAllowedActions implements ProtocolObject {
    static CLASSID : number =  15;

    classId() {

        return InformFutureAllowedActions.CLASSID;
    }
    public actions : FuturePlayerAction[];
    public callAmount : string;
    public minBetAmount : string;

    constructor(actions? : FuturePlayerAction[], callAmount? : string, minBetAmount? : string) {
        this.actions = actions;
        this.callAmount = callAmount;
        this.minBetAmount = minBetAmount;
    }

    public save(ba : ByteArray) :  void {
        if (!this.actions) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.actions.length);
            for(let i = 0; i != this.actions.length; ++i)
                this.actions[i].save(ba);
        }
        ba.writeString(this.callAmount);
        ba.writeString(this.minBetAmount);
    }

    public load(ba : ByteArray) : void {
        let actionsCount : number = ba.readInt();
        this.actions = [];
        for(let i = 0; i != actionsCount; ++i) {
            let _tmp : FuturePlayerAction = new FuturePlayerAction();
            _tmp.load(ba);
            this.actions.push(_tmp);
        }
        this.callAmount = ba.readString();
        this.minBetAmount = ba.readString();
    }
}
export class HandStartInfo implements ProtocolObject {
    static CLASSID : number =  16;

    classId() {

        return HandStartInfo.CLASSID;
    }
    public handId : string;
    public handIndex : string;

    constructor(handId? : string, handIndex? : string) {
        this.handId = handId;
        this.handIndex = handIndex;
    }

    public save(ba : ByteArray) :  void {
        ba.writeString(this.handId);
        ba.writeString(this.handIndex);
    }

    public load(ba : ByteArray) : void {
        this.handId = ba.readString();
        this.handIndex = ba.readString();
    }
}
export class DealerButton implements ProtocolObject {
    static CLASSID : number =  17;

    classId() {

        return DealerButton.CLASSID;
    }
    public seat : number;

    constructor(seat? : number) {
        this.seat = seat;
    }

    public save(ba : ByteArray) :  void {
        ba.writeByte(this.seat);
    }

    public load(ba : ByteArray) : void {
        this.seat = ba.readByte();
    }
}
export class StartDealPocketCards implements ProtocolObject {
    static CLASSID : number =  18;

    classId() {

        return StartDealPocketCards.CLASSID;
    }
    public deal : number;

    constructor(deal? : number) {
        this.deal = deal;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.deal);
    }

    public load(ba : ByteArray) : void {
        this.deal = ba.readInt();
    }
}
export class StopDealPocketCards implements ProtocolObject {
    static CLASSID : number =  19;

    classId() {

        return StopDealPocketCards.CLASSID;
    }
    public deal : number;

    constructor(deal? : number) {
        this.deal = deal;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.deal);
    }

    public load(ba : ByteArray) : void {
        this.deal = ba.readInt();
    }
}
export class DealPublicCards implements ProtocolObject {
    static CLASSID : number =  20;

    classId() {

        return DealPublicCards.CLASSID;
    }
    public cards : GameCard[];
    public handId : number;
    public startingSeqId : number;

    constructor(cards? : GameCard[], handId? : number, startingSeqId? : number) {
        this.cards = cards;
        this.handId = handId;
        this.startingSeqId = startingSeqId;
    }

    public save(ba : ByteArray) :  void {
        if (!this.cards) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.cards.length);
            for(let i = 0; i != this.cards.length; ++i)
                this.cards[i].save(ba);
        }
        ba.writeInt(this.handId);
        ba.writeInt(this.startingSeqId);
    }

    public load(ba : ByteArray) : void {
        let cardsCount : number = ba.readInt();
        this.cards = [];
        for(let i = 0; i != cardsCount; ++i) {
            let _tmp : GameCard = new GameCard();
            _tmp.load(ba);
            this.cards.push(_tmp);
        }
        this.handId = ba.readInt();
        this.startingSeqId = ba.readInt();
    }
}
export class RedealCommunityCards implements ProtocolObject {
    static CLASSID : number =  21;

    classId() {

        return RedealCommunityCards.CLASSID;
    }
    public removed : GameCard[];
    public added : GameCard[];

    constructor(removed? : GameCard[], added? : GameCard[]) {
        this.removed = removed;
        this.added = added;
    }

    public save(ba : ByteArray) :  void {
        if (!this.removed) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.removed.length);
            for(let i = 0; i != this.removed.length; ++i)
                this.removed[i].save(ba);
        }
        if (!this.added) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.added.length);
            for(let i = 0; i != this.added.length; ++i)
                this.added[i].save(ba);
        }
    }

    public load(ba : ByteArray) : void {
        let removedCount : number = ba.readInt();
        this.removed = [];
        for(let i = 0; i != removedCount; ++i) {
            let _tmp : GameCard = new GameCard();
            _tmp.load(ba);
            this.removed.push(_tmp);
        }
        let addedCount : number = ba.readInt();
        this.added = [];
        for(let i = 0; i != addedCount; ++i) {
            let _tmp : GameCard = new GameCard();
            _tmp.load(ba);
            this.added.push(_tmp);
        }
    }
}
export class DealPrivateCards implements ProtocolObject {
    static CLASSID : number =  22;

    classId() {

        return DealPrivateCards.CLASSID;
    }
    public cards : CardToDeal[];
    public handId : number;

    constructor(cards? : CardToDeal[], handId? : number) {
        this.cards = cards;
        this.handId = handId;
    }

    public save(ba : ByteArray) :  void {
        if (!this.cards) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.cards.length);
            for(let i = 0; i != this.cards.length; ++i)
                this.cards[i].save(ba);
        }
        ba.writeInt(this.handId);
    }

    public load(ba : ByteArray) : void {
        let cardsCount : number = ba.readInt();
        this.cards = [];
        for(let i = 0; i != cardsCount; ++i) {
            let _tmp : CardToDeal = new CardToDeal();
            _tmp.load(ba);
            this.cards.push(_tmp);
        }
        this.handId = ba.readInt();
    }
}
export class ExposePrivateCards implements ProtocolObject {
    static CLASSID : number =  23;

    classId() {

        return ExposePrivateCards.CLASSID;
    }
    public cards : CardToDeal[];

    constructor(cards? : CardToDeal[]) {
        this.cards = cards;
    }

    public save(ba : ByteArray) :  void {
        if (!this.cards) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.cards.length);
            for(let i = 0; i != this.cards.length; ++i)
                this.cards[i].save(ba);
        }
    }

    public load(ba : ByteArray) : void {
        let cardsCount : number = ba.readInt();
        this.cards = [];
        for(let i = 0; i != cardsCount; ++i) {
            let _tmp : CardToDeal = new CardToDeal();
            _tmp.load(ba);
            this.cards.push(_tmp);
        }
    }
}
export class HandEnd implements ProtocolObject {
    static CLASSID : number =  24;

    classId() {

        return HandEnd.CLASSID;
    }
    playerIdRevealOrder : number[]  = [];
    public hands : BestHand[];
    public lowHands : BestLowHand[];
    public potTransfers : PotTransfers;
    public potShares : PotShare[];

    constructor(playerIdRevealOrder? : number[], hands? : BestHand[], lowHands? : BestLowHand[], potTransfers? : PotTransfers, potShares? : PotShare[]) {
        this.playerIdRevealOrder = playerIdRevealOrder;
        this.hands = hands;
        this.lowHands = lowHands;
        this.potTransfers = potTransfers;
        this.potShares = potShares;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.playerIdRevealOrder.length);
        for(let i = 0; i != this.playerIdRevealOrder.length; ++i) {
            ba.writeInt(this.playerIdRevealOrder[i]);
        }
        if (!this.hands) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.hands.length);
            for(let i = 0; i != this.hands.length; ++i)
                this.hands[i].save(ba);
        }
        if (!this.lowHands) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.lowHands.length);
            for(let i = 0; i != this.lowHands.length; ++i)
                this.lowHands[i].save(ba);
        }
        this.potTransfers.save(ba);
        if (!this.potShares) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.potShares.length);
            for(let i = 0; i != this.potShares.length; ++i)
                this.potShares[i].save(ba);
        }
    }

    public load(ba : ByteArray) : void {
        let playerIdRevealOrderCount : number = ba.readInt();
        this.playerIdRevealOrder = [];
        for (let i = 0; i < playerIdRevealOrderCount; i ++) {
            this.playerIdRevealOrder.push(ba.readInt());
        }
        let handsCount : number = ba.readInt();
        this.hands = [];
        for(let i = 0; i != handsCount; ++i) {
            let _tmp : BestHand = new BestHand();
            _tmp.load(ba);
            this.hands.push(_tmp);
        }
        let lowHandsCount : number = ba.readInt();
        this.lowHands = [];
        for(let i = 0; i != lowHandsCount; ++i) {
            let _tmp : BestLowHand = new BestLowHand();
            _tmp.load(ba);
            this.lowHands.push(_tmp);
        }
        this.potTransfers = new PotTransfers();
        this.potTransfers.load(ba);
        let potSharesCount : number = ba.readInt();
        this.potShares = [];
        for(let i = 0; i != potSharesCount; ++i) {
            let _tmp : PotShare = new PotShare();
            _tmp.load(ba);
            this.potShares.push(_tmp);
        }
    }
}
export class HandCanceled implements ProtocolObject {
    static CLASSID : number =  25;

    classId() {

        return HandCanceled.CLASSID;
    }

    constructor() {
    }

    public save(ba : ByteArray) :  void {
    }

    public load(ba : ByteArray) : void {
    }
}
export class ClearTable implements ProtocolObject {
    static CLASSID : number =  26;

    classId() {

        return ClearTable.CLASSID;
    }

    constructor() {
    }

    public save(ba : ByteArray) :  void {
    }

    public load(ba : ByteArray) : void {
    }
}
export class StartHandHistory implements ProtocolObject {
    static CLASSID : number =  27;

    classId() {

        return StartHandHistory.CLASSID;
    }

    constructor() {
    }

    public save(ba : ByteArray) :  void {
    }

    public load(ba : ByteArray) : void {
    }
}
export class StopHandHistory implements ProtocolObject {
    static CLASSID : number =  28;

    classId() {

        return StopHandHistory.CLASSID;
    }

    constructor() {
    }

    public save(ba : ByteArray) :  void {
    }

    public load(ba : ByteArray) : void {
    }
}
export class PerformAction implements ProtocolObject {
    static CLASSID : number =  29;

    classId() {

        return PerformAction.CLASSID;
    }
    public seq : number;
    public player : number;
    public action : PlayerAction;
    public betAmount : string;
    public raiseAmount : string;
    public stackAmount : string;
    public timeout : boolean;
    public automatic : boolean;
    cards : number[]  = [];
    public payload : number[];

    constructor(seq? : number, player? : number, action? : PlayerAction, betAmount? : string, raiseAmount? : string, stackAmount? : string, timeout? : boolean, automatic? : boolean, cards? : number[], payload? : number[]) {
        this.seq = seq;
        this.player = player;
        this.action = action;
        this.betAmount = betAmount;
        this.raiseAmount = raiseAmount;
        this.stackAmount = stackAmount;
        this.timeout = timeout;
        this.automatic = automatic;
        this.cards = cards;
        this.payload = payload;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.seq);
        ba.writeInt(this.player);
        this.action.save(ba);
        ba.writeString(this.betAmount);
        ba.writeString(this.raiseAmount);
        ba.writeString(this.stackAmount);
        ba.writeBoolean(this.timeout);
        ba.writeBoolean(this.automatic);
        ba.writeInt(this.cards.length);
        for(let i = 0; i != this.cards.length; ++i) {
            ba.writeInt(this.cards[i]);
        }
        ba.writeInt(this.payload.length);
        for(let i = 0; i != this.payload.length; ++i) {
            ba.writeUnsignedByte(this.payload[i]);
        }
    }

    public load(ba : ByteArray) : void {
        this.seq = ba.readInt();
        this.player = ba.readInt();
        this.action = new PlayerAction();
        this.action.load(ba);
        this.betAmount = ba.readString();
        this.raiseAmount = ba.readString();
        this.stackAmount = ba.readString();
        this.timeout = ba.readBoolean();
        this.automatic = ba.readBoolean();
        let cardsCount : number = ba.readInt();
        this.cards = [];
        for (let i = 0; i < cardsCount; i ++) {
            this.cards.push(ba.readInt());
        }
        let a = ba.readInt();
        this.payload = ba.readArray(a);
    }
}
export class ChessClock implements ProtocolObject {
    static CLASSID : number =  33;

    classId() {

        return ChessClock.CLASSID;
    }
    public playerId : number;
    public startTime : string;
    public remainingTime : string;

    constructor(playerId? : number, startTime? : string, remainingTime? : string) {
        this.playerId = playerId;
        this.startTime = startTime;
        this.remainingTime = remainingTime;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.playerId);
        ba.writeString(this.startTime);
        ba.writeString(this.remainingTime);
    }

    public load(ba : ByteArray) : void {
        this.playerId = ba.readInt();
        this.startTime = ba.readString();
        this.remainingTime = ba.readString();
    }
}
export class HandStartsIn implements ProtocolObject {
    static CLASSID : number =  35;

    classId() {

        return HandStartsIn.CLASSID;
    }
    public time : string;

    constructor(time? : string) {
        this.time = time;
    }

    public save(ba : ByteArray) :  void {
        ba.writeString(this.time);
    }

    public load(ba : ByteArray) : void {
        this.time = ba.readString();
    }
}
export class CardAction implements ProtocolObject {
    static CLASSID : number =  37;

    classId() {

        return CardAction.CLASSID;
    }
    public cardId : number;
    public card : GameCard;
    public morePicksAvailable : boolean;

    constructor(cardId? : number, card? : GameCard, morePicksAvailable? : boolean) {
        this.cardId = cardId;
        this.card = card;
        this.morePicksAvailable = morePicksAvailable;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.cardId);
        this.card.save(ba);
        ba.writeBoolean(this.morePicksAvailable);
    }

    public load(ba : ByteArray) : void {
        this.cardId = ba.readInt();
        this.card = new GameCard();
        this.card.load(ba);
        this.morePicksAvailable = ba.readBoolean();
    }
}
export class PositionCardsAction implements ProtocolObject {
    static CLASSID : number =  38;

    classId() {

        return PositionCardsAction.CLASSID;
    }
    public cardPositions : CardPosition[];
    public cards : GameCard[];

    constructor(cardPositions? : CardPosition[], cards? : GameCard[]) {
        this.cardPositions = cardPositions;
        this.cards = cards;
    }

    public save(ba : ByteArray) :  void {
        if (!this.cardPositions) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.cardPositions.length);
            for(let i = 0; i != this.cardPositions.length; ++i) {
                ba.writeUnsignedByte(this.cardPositions[i]);
            }
        }
        if (!this.cards) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.cards.length);
            for(let i = 0; i != this.cards.length; ++i)
                this.cards[i].save(ba);
        }
    }

    public load(ba : ByteArray) : void {
        let cardPositionsCount : number = ba.readInt();
        this.cardPositions = [];
        for(let i = 0; i != cardPositionsCount; ++i) {
            let ordinal : number = ba.readUnsignedByte();
            let _tmp : CardPosition = ordinal;
            this.cardPositions.push(_tmp);
        }
        let cardsCount : number = ba.readInt();
        this.cards = [];
        for(let i = 0; i != cardsCount; ++i) {
            let _tmp : GameCard = new GameCard();
            _tmp.load(ba);
            this.cards.push(_tmp);
        }
    }
}
export class PlayerBetStack implements ProtocolObject {
    static CLASSID : number =  40;

    classId() {

        return PlayerBetStack.CLASSID;
    }
    public playerId : number;
    public betStack : string;
    public balance : string;

    constructor(playerId? : number, betStack? : string, balance? : string) {
        this.playerId = playerId;
        this.betStack = betStack;
        this.balance = balance;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.playerId);
        ba.writeString(this.betStack);
        ba.writeString(this.balance);
    }

    public load(ba : ByteArray) : void {
        this.playerId = ba.readInt();
        this.betStack = ba.readString();
        this.balance = ba.readString();
    }
}
export class BetStackChanged implements ProtocolObject {
    static CLASSID : number =  41;

    classId() {

        return BetStackChanged.CLASSID;
    }
    public playerThatActedId : number;
    public betStacks : PlayerBetStack[];

    constructor(playerThatActedId? : number, betStacks? : PlayerBetStack[]) {
        this.playerThatActedId = playerThatActedId;
        this.betStacks = betStacks;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.playerThatActedId);
        if (!this.betStacks) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.betStacks.length);
            for(let i = 0; i != this.betStacks.length; ++i)
                this.betStacks[i].save(ba);
        }
    }

    public load(ba : ByteArray) : void {
        this.playerThatActedId = ba.readInt();
        let betStacksCount : number = ba.readInt();
        this.betStacks = [];
        for(let i = 0; i != betStacksCount; ++i) {
            let _tmp : PlayerBetStack = new PlayerBetStack();
            _tmp.load(ba);
            this.betStacks.push(_tmp);
        }
    }
}
export class CardChanged implements ProtocolObject {
    static CLASSID : number =  42;

    classId() {

        return CardChanged.CLASSID;
    }
    public playerThatActedId : number;
    public fromCard : GameCard;
    public toCard : GameCard;

    constructor(playerThatActedId? : number, fromCard? : GameCard, toCard? : GameCard) {
        this.playerThatActedId = playerThatActedId;
        this.fromCard = fromCard;
        this.toCard = toCard;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.playerThatActedId);
        this.fromCard.save(ba);
        this.toCard.save(ba);
    }

    public load(ba : ByteArray) : void {
        this.playerThatActedId = ba.readInt();
        this.fromCard = new GameCard();
        this.fromCard.load(ba);
        this.toCard = new GameCard();
        this.toCard.load(ba);
    }
}
export class TournamentOut implements ProtocolObject {
    static CLASSID : number =  43;

    classId() {

        return TournamentOut.CLASSID;
    }
    public player : number;
    public position : number;
    public prizeWon : string;
    public currencyCode : string;
    public eliminationCount : number;
    public offerReEntry : boolean;
    public entryIndex : number;

    constructor(player? : number, position? : number, prizeWon? : string, currencyCode? : string, eliminationCount? : number, offerReEntry? : boolean, entryIndex? : number) {
        this.player = player;
        this.position = position;
        this.prizeWon = prizeWon;
        this.currencyCode = currencyCode;
        this.eliminationCount = eliminationCount;
        this.offerReEntry = offerReEntry;
        this.entryIndex = entryIndex;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.player);
        ba.writeInt(this.position);
        ba.writeString(this.prizeWon);
        ba.writeString(this.currencyCode);
        ba.writeInt(this.eliminationCount);
        ba.writeBoolean(this.offerReEntry);
        ba.writeInt(this.entryIndex);
    }

    public load(ba : ByteArray) : void {
        this.player = ba.readInt();
        this.position = ba.readInt();
        this.prizeWon = ba.readString();
        this.currencyCode = ba.readString();
        this.eliminationCount = ba.readInt();
        this.offerReEntry = ba.readBoolean();
        this.entryIndex = ba.readInt();
    }
}
export class PlayerBalance implements ProtocolObject {
    static CLASSID : number =  44;

    classId() {

        return PlayerBalance.CLASSID;
    }
    public balance : string;
    public pendingBalance : string;
    public player : number;
    public playersContributionToPot : string;
    public endOfHand : boolean;

    constructor(balance? : string, pendingBalance? : string, player? : number, playersContributionToPot? : string, endOfHand? : boolean) {
        this.balance = balance;
        this.pendingBalance = pendingBalance;
        this.player = player;
        this.playersContributionToPot = playersContributionToPot;
        this.endOfHand = endOfHand;
    }

    public save(ba : ByteArray) :  void {
        ba.writeString(this.balance);
        ba.writeString(this.pendingBalance);
        ba.writeInt(this.player);
        ba.writeString(this.playersContributionToPot);
        ba.writeBoolean(this.endOfHand);
    }

    public load(ba : ByteArray) : void {
        this.balance = ba.readString();
        this.pendingBalance = ba.readString();
        this.player = ba.readInt();
        this.playersContributionToPot = ba.readString();
        this.endOfHand = ba.readBoolean();
    }
}
export class BuyInInfoRequest implements ProtocolObject {
    static CLASSID : number =  45;

    classId() {

        return BuyInInfoRequest.CLASSID;
    }
    public auto : boolean;

    constructor(auto? : boolean) {
        this.auto = auto;
    }

    public save(ba : ByteArray) :  void {
        ba.writeBoolean(this.auto);
    }

    public load(ba : ByteArray) : void {
        this.auto = ba.readBoolean();
    }
}
export class BuyInInfoResponse implements ProtocolObject {
    static CLASSID : number =  46;

    classId() {

        return BuyInInfoResponse.CLASSID;
    }
    public maxAmount : string;
    public minAmount : string;
    public balanceInWallet : string;
    public balanceOnTable : string;
    public mandatoryBuyin : boolean;
    public resultCode : BuyInInfoResultCode = 0;
    public currencyCode : string;
    public tableMaxAmount : string;
    public tableMinAmount : string;
    public bigBlind : string;
    public betStrategy : BetStrategy = 0;
    public auto : boolean;
    public playerCurrencyCode : string;
    public playerMinAmount : string;
    public playerMaxAmount : string;

    constructor(maxAmount? : string, minAmount? : string, balanceInWallet? : string, balanceOnTable? : string, mandatoryBuyin? : boolean, resultCode? : BuyInInfoResultCode, currencyCode? : string, tableMaxAmount? : string, tableMinAmount? : string, bigBlind? : string, betStrategy? : BetStrategy, auto? : boolean, playerCurrencyCode? : string, playerMinAmount? : string, playerMaxAmount? : string) {
        this.maxAmount = maxAmount;
        this.minAmount = minAmount;
        this.balanceInWallet = balanceInWallet;
        this.balanceOnTable = balanceOnTable;
        this.mandatoryBuyin = mandatoryBuyin;
        this.resultCode = resultCode;
        this.currencyCode = currencyCode;
        this.tableMaxAmount = tableMaxAmount;
        this.tableMinAmount = tableMinAmount;
        this.bigBlind = bigBlind;
        this.betStrategy = betStrategy;
        this.auto = auto;
        this.playerCurrencyCode = playerCurrencyCode;
        this.playerMinAmount = playerMinAmount;
        this.playerMaxAmount = playerMaxAmount;
    }

    public save(ba : ByteArray) :  void {
        ba.writeString(this.maxAmount);
        ba.writeString(this.minAmount);
        ba.writeString(this.balanceInWallet);
        ba.writeString(this.balanceOnTable);
        ba.writeBoolean(this.mandatoryBuyin);
        if (typeof(this.resultCode) == "undefined") {
            ba.writeUnsignedByte(-1);
        } else {
            ba.writeUnsignedByte(this.resultCode);
        }
        ba.writeString(this.currencyCode);
        ba.writeString(this.tableMaxAmount);
        ba.writeString(this.tableMinAmount);
        ba.writeString(this.bigBlind);
        if (typeof(this.betStrategy) == "undefined") {
            ba.writeUnsignedByte(-1);
        } else {
            ba.writeUnsignedByte(this.betStrategy);
        }
        ba.writeBoolean(this.auto);
        ba.writeString(this.playerCurrencyCode);
        ba.writeString(this.playerMinAmount);
        ba.writeString(this.playerMaxAmount);
    }

    public load(ba : ByteArray) : void {
        this.maxAmount = ba.readString();
        this.minAmount = ba.readString();
        this.balanceInWallet = ba.readString();
        this.balanceOnTable = ba.readString();
        this.mandatoryBuyin = ba.readBoolean();
        this.resultCode = ba.readUnsignedByte();
        this.currencyCode = ba.readString();
        this.tableMaxAmount = ba.readString();
        this.tableMinAmount = ba.readString();
        this.bigBlind = ba.readString();
        this.betStrategy = ba.readUnsignedByte();
        this.auto = ba.readBoolean();
        this.playerCurrencyCode = ba.readString();
        this.playerMinAmount = ba.readString();
        this.playerMaxAmount = ba.readString();
    }
}
export class BuyInRequest implements ProtocolObject {
    static CLASSID : number =  47;

    classId() {

        return BuyInRequest.CLASSID;
    }
    public amount : string;
    public sitInIfSuccessful : boolean;

    constructor(amount? : string, sitInIfSuccessful? : boolean) {
        this.amount = amount;
        this.sitInIfSuccessful = sitInIfSuccessful;
    }

    public save(ba : ByteArray) :  void {
        ba.writeString(this.amount);
        ba.writeBoolean(this.sitInIfSuccessful);
    }

    public load(ba : ByteArray) : void {
        this.amount = ba.readString();
        this.sitInIfSuccessful = ba.readBoolean();
    }
}
export class BuyInCancel implements ProtocolObject {
    static CLASSID : number =  48;

    classId() {

        return BuyInCancel.CLASSID;
    }

    constructor() {
    }

    public save(ba : ByteArray) :  void {
    }

    public load(ba : ByteArray) : void {
    }
}
export class BuyInResponse implements ProtocolObject {
    static CLASSID : number =  49;

    classId() {

        return BuyInResponse.CLASSID;
    }
    public balance : string;
    public pendingBalance : string;
    public amountBroughtIn : string;
    public resultCode : BuyInResultCode = 0;

    constructor(balance? : string, pendingBalance? : string, amountBroughtIn? : string, resultCode? : BuyInResultCode) {
        this.balance = balance;
        this.pendingBalance = pendingBalance;
        this.amountBroughtIn = amountBroughtIn;
        this.resultCode = resultCode;
    }

    public save(ba : ByteArray) :  void {
        ba.writeString(this.balance);
        ba.writeString(this.pendingBalance);
        ba.writeString(this.amountBroughtIn);
        if (typeof(this.resultCode) == "undefined") {
            ba.writeUnsignedByte(-1);
        } else {
            ba.writeUnsignedByte(this.resultCode);
        }
    }

    public load(ba : ByteArray) : void {
        this.balance = ba.readString();
        this.pendingBalance = ba.readString();
        this.amountBroughtIn = ba.readString();
        this.resultCode = ba.readUnsignedByte();
    }
}
export class TournamentBuyInResponse implements ProtocolObject {
    static CLASSID : number =  50;

    classId() {

        return TournamentBuyInResponse.CLASSID;
    }
    public resultCode : BuyInResultCode = 0;

    constructor(resultCode? : BuyInResultCode) {
        this.resultCode = resultCode;
    }

    public save(ba : ByteArray) :  void {
        if (typeof(this.resultCode) == "undefined") {
            ba.writeUnsignedByte(-1);
        } else {
            ba.writeUnsignedByte(this.resultCode);
        }
    }

    public load(ba : ByteArray) : void {
        this.resultCode = ba.readUnsignedByte();
    }
}
export class Pot implements ProtocolObject {
    static CLASSID : number =  51;

    classId() {

        return Pot.CLASSID;
    }
    public id : number;
    public type : PotType = 0;
    public amount : string;

    constructor(id? : number, type? : PotType, amount? : string) {
        this.id = id;
        this.type = type;
        this.amount = amount;
    }

    public save(ba : ByteArray) :  void {
        ba.writeByte(this.id);
        if (typeof(this.type) == "undefined") {
            ba.writeUnsignedByte(-1);
        } else {
            ba.writeUnsignedByte(this.type);
        }
        ba.writeString(this.amount);
    }

    public load(ba : ByteArray) : void {
        this.id = ba.readByte();
        this.type = ba.readUnsignedByte();
        this.amount = ba.readString();
    }
}
export class PotTransfer implements ProtocolObject {
    static CLASSID : number =  52;

    classId() {

        return PotTransfer.CLASSID;
    }
    public potId : number;
    public playerId : number;
    public amount : string;

    constructor(potId? : number, playerId? : number, amount? : string) {
        this.potId = potId;
        this.playerId = playerId;
        this.amount = amount;
    }

    public save(ba : ByteArray) :  void {
        ba.writeByte(this.potId);
        ba.writeInt(this.playerId);
        ba.writeString(this.amount);
    }

    public load(ba : ByteArray) : void {
        this.potId = ba.readByte();
        this.playerId = ba.readInt();
        this.amount = ba.readString();
    }
}
export class PotTransfers implements ProtocolObject {
    static CLASSID : number =  53;

    classId() {

        return PotTransfers.CLASSID;
    }
    public fromPlayerToPot : boolean;
    public transfers : PotTransfer[];
    public pots : Pot[];
    public totalPotSize : string;

    constructor(fromPlayerToPot? : boolean, transfers? : PotTransfer[], pots? : Pot[], totalPotSize? : string) {
        this.fromPlayerToPot = fromPlayerToPot;
        this.transfers = transfers;
        this.pots = pots;
        this.totalPotSize = totalPotSize;
    }

    public save(ba : ByteArray) :  void {
        ba.writeBoolean(this.fromPlayerToPot);
        if (!this.transfers) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.transfers.length);
            for(let i = 0; i != this.transfers.length; ++i)
                this.transfers[i].save(ba);
        }
        if (!this.pots) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.pots.length);
            for(let i = 0; i != this.pots.length; ++i)
                this.pots[i].save(ba);
        }
        ba.writeString(this.totalPotSize);
    }

    public load(ba : ByteArray) : void {
        this.fromPlayerToPot = ba.readBoolean();
        let transfersCount : number = ba.readInt();
        this.transfers = [];
        for(let i = 0; i != transfersCount; ++i) {
            let _tmp : PotTransfer = new PotTransfer();
            _tmp.load(ba);
            this.transfers.push(_tmp);
        }
        let potsCount : number = ba.readInt();
        this.pots = [];
        for(let i = 0; i != potsCount; ++i) {
            let _tmp : Pot = new Pot();
            _tmp.load(ba);
            this.pots.push(_tmp);
        }
        this.totalPotSize = ba.readString();
    }
}
export class TakeBackUncalledBet implements ProtocolObject {
    static CLASSID : number =  54;

    classId() {

        return TakeBackUncalledBet.CLASSID;
    }
    public playerId : number;
    public amount : string;

    constructor(playerId? : number, amount? : string) {
        this.playerId = playerId;
        this.amount = amount;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.playerId);
        ba.writeString(this.amount);
    }

    public load(ba : ByteArray) : void {
        this.playerId = ba.readInt();
        this.amount = ba.readString();
    }
}
export class PlayerPokerStatus implements ProtocolObject {
    static CLASSID : number =  56;

    classId() {

        return PlayerPokerStatus.CLASSID;
    }
    public player : number;
    public status : PlayerTableStatus = 0;
    public inCurrentHand : boolean;
    public sitOutNextHand : boolean;
    public away : boolean;

    constructor(player? : number, status? : PlayerTableStatus, inCurrentHand? : boolean, sitOutNextHand? : boolean, away? : boolean) {
        this.player = player;
        this.status = status;
        this.inCurrentHand = inCurrentHand;
        this.sitOutNextHand = sitOutNextHand;
        this.away = away;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.player);
        if (typeof(this.status) == "undefined") {
            ba.writeUnsignedByte(-1);
        } else {
            ba.writeUnsignedByte(this.status);
        }
        ba.writeBoolean(this.inCurrentHand);
        ba.writeBoolean(this.sitOutNextHand);
        ba.writeBoolean(this.away);
    }

    public load(ba : ByteArray) : void {
        this.player = ba.readInt();
        this.status = ba.readUnsignedByte();
        this.inCurrentHand = ba.readBoolean();
        this.sitOutNextHand = ba.readBoolean();
        this.away = ba.readBoolean();
    }
}
export class PlayerHandStartStatus implements ProtocolObject {
    static CLASSID : number =  57;

    classId() {

        return PlayerHandStartStatus.CLASSID;
    }
    public player : number;
    public status : PlayerTableStatus = 0;
    public away : boolean;
    public sitOutNextHand : boolean;

    constructor(player? : number, status? : PlayerTableStatus, away? : boolean, sitOutNextHand? : boolean) {
        this.player = player;
        this.status = status;
        this.away = away;
        this.sitOutNextHand = sitOutNextHand;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.player);
        if (typeof(this.status) == "undefined") {
            ba.writeUnsignedByte(-1);
        } else {
            ba.writeUnsignedByte(this.status);
        }
        ba.writeBoolean(this.away);
        ba.writeBoolean(this.sitOutNextHand);
    }

    public load(ba : ByteArray) : void {
        this.player = ba.readInt();
        this.status = ba.readUnsignedByte();
        this.away = ba.readBoolean();
        this.sitOutNextHand = ba.readBoolean();
    }
}
export class PlayerSitinRequest implements ProtocolObject {
    static CLASSID : number =  58;

    classId() {

        return PlayerSitinRequest.CLASSID;
    }
    public player : number;

    constructor(player? : number) {
        this.player = player;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.player);
    }

    public load(ba : ByteArray) : void {
        this.player = ba.readInt();
    }
}
export class PlayerSitoutRequest implements ProtocolObject {
    static CLASSID : number =  59;

    classId() {

        return PlayerSitoutRequest.CLASSID;
    }
    public player : number;

    constructor(player? : number) {
        this.player = player;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.player);
    }

    public load(ba : ByteArray) : void {
        this.player = ba.readInt();
    }
}
export class RoundInfoUpdate implements ProtocolObject {
    static CLASSID : number =  60;

    classId() {

        return RoundInfoUpdate.CLASSID;
    }
    public message : string;
    public number : number;

    constructor(message? : string, number? : number) {
        this.message = message;
        this.number = number;
    }

    public save(ba : ByteArray) :  void {
        ba.writeString(this.message);
        ba.writeInt(this.number);
    }

    public load(ba : ByteArray) : void {
        this.message = ba.readString();
        this.number = ba.readInt();
    }
}
export class TournamentPositionUpdate implements ProtocolObject {
    static CLASSID : number =  61;

    classId() {

        return TournamentPositionUpdate.CLASSID;
    }
    public playerId : number;
    public position : number;
    public remainingPlayer : number;

    constructor(playerId? : number, position? : number, remainingPlayer? : number) {
        this.playerId = playerId;
        this.position = position;
        this.remainingPlayer = remainingPlayer;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.playerId);
        ba.writeInt(this.position);
        ba.writeInt(this.remainingPlayer);
    }

    public load(ba : ByteArray) : void {
        this.playerId = ba.readInt();
        this.position = ba.readInt();
        this.remainingPlayer = ba.readInt();
    }
}
export class DeckInfo implements ProtocolObject {
    static CLASSID : number =  62;

    classId() {

        return DeckInfo.CLASSID;
    }
    public size : number;
    public rankLow : Rank = 0;

    constructor(size? : number, rankLow? : Rank) {
        this.size = size;
        this.rankLow = rankLow;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.size);
        if (typeof(this.rankLow) == "undefined") {
            ba.writeUnsignedByte(-1);
        } else {
            ba.writeUnsignedByte(this.rankLow);
        }
    }

    public load(ba : ByteArray) : void {
        this.size = ba.readInt();
        this.rankLow = ba.readUnsignedByte();
    }
}
export class ExternalSessionInfoPacket implements ProtocolObject {
    static CLASSID : number =  63;

    classId() {

        return ExternalSessionInfoPacket.CLASSID;
    }
    public externalTableReference : string;
    public externalTableSessionReference : string;

    constructor(externalTableReference? : string, externalTableSessionReference? : string) {
        this.externalTableReference = externalTableReference;
        this.externalTableSessionReference = externalTableSessionReference;
    }

    public save(ba : ByteArray) :  void {
        ba.writeString(this.externalTableReference);
        ba.writeString(this.externalTableSessionReference);
    }

    public load(ba : ByteArray) : void {
        this.externalTableReference = ba.readString();
        this.externalTableSessionReference = ba.readString();
    }
}
export class PlayerDisconnectedPacket implements ProtocolObject {
    static CLASSID : number =  64;

    classId() {

        return PlayerDisconnectedPacket.CLASSID;
    }
    public playerId : number;
    public timebank : number;

    constructor(playerId? : number, timebank? : number) {
        this.playerId = playerId;
        this.timebank = timebank;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.playerId);
        ba.writeInt(this.timebank);
    }

    public load(ba : ByteArray) : void {
        this.playerId = ba.readInt();
        this.timebank = ba.readInt();
    }
}
export class PlayerReconnectedPacket implements ProtocolObject {
    static CLASSID : number =  65;

    classId() {

        return PlayerReconnectedPacket.CLASSID;
    }
    public playerId : number;

    constructor(playerId? : number) {
        this.playerId = playerId;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.playerId);
    }

    public load(ba : ByteArray) : void {
        this.playerId = ba.readInt();
    }
}
export class PingPacket implements ProtocolObject {
    static CLASSID : number =  66;

    classId() {

        return PingPacket.CLASSID;
    }
    public identifier : number;

    constructor(identifier? : number) {
        this.identifier = identifier;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.identifier);
    }

    public load(ba : ByteArray) : void {
        this.identifier = ba.readInt();
    }
}
export class PongPacket implements ProtocolObject {
    static CLASSID : number =  67;

    classId() {

        return PongPacket.CLASSID;
    }
    public identifier : number;

    constructor(identifier? : number) {
        this.identifier = identifier;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.identifier);
    }

    public load(ba : ByteArray) : void {
        this.identifier = ba.readInt();
    }
}
export class WaitingToStartBreak implements ProtocolObject {
    static CLASSID : number =  68;

    classId() {

        return WaitingToStartBreak.CLASSID;
    }

    constructor() {
    }

    public save(ba : ByteArray) :  void {
    }

    public load(ba : ByteArray) : void {
    }
}
export class WaitingForPlayers implements ProtocolObject {
    static CLASSID : number =  69;

    classId() {

        return WaitingForPlayers.CLASSID;
    }

    constructor() {
    }

    public save(ba : ByteArray) :  void {
    }

    public load(ba : ByteArray) : void {
    }
}
export class BlindsAreUpdated implements ProtocolObject {
    static CLASSID : number =  70;

    classId() {

        return BlindsAreUpdated.CLASSID;
    }
    public level : BlindsLevel;
    public secondsToNextLevel : number;

    constructor(level? : BlindsLevel, secondsToNextLevel? : number) {
        this.level = level;
        this.secondsToNextLevel = secondsToNextLevel;
    }

    public save(ba : ByteArray) :  void {
        this.level.save(ba);
        ba.writeInt(this.secondsToNextLevel);
    }

    public load(ba : ByteArray) : void {
        this.level = new BlindsLevel();
        this.level.load(ba);
        this.secondsToNextLevel = ba.readInt();
    }
}
export class BlindsLevel implements ProtocolObject {
    static CLASSID : number =  71;

    classId() {

        return BlindsLevel.CLASSID;
    }
    public smallBlind : string;
    public bigBlind : string;
    public ante : string;
    public isBreak : boolean;
    public durationInMinutes : number;

    constructor(smallBlind? : string, bigBlind? : string, ante? : string, isBreak? : boolean, durationInMinutes? : number) {
        this.smallBlind = smallBlind;
        this.bigBlind = bigBlind;
        this.ante = ante;
        this.isBreak = isBreak;
        this.durationInMinutes = durationInMinutes;
    }

    public save(ba : ByteArray) :  void {
        ba.writeString(this.smallBlind);
        ba.writeString(this.bigBlind);
        ba.writeString(this.ante);
        ba.writeBoolean(this.isBreak);
        ba.writeInt(this.durationInMinutes);
    }

    public load(ba : ByteArray) : void {
        this.smallBlind = ba.readString();
        this.bigBlind = ba.readString();
        this.ante = ba.readString();
        this.isBreak = ba.readBoolean();
        this.durationInMinutes = ba.readInt();
    }
}
export class RequestTournamentPlayerList implements ProtocolObject {
    static CLASSID : number =  72;

    classId() {

        return RequestTournamentPlayerList.CLASSID;
    }

    constructor() {
    }

    public save(ba : ByteArray) :  void {
    }

    public load(ba : ByteArray) : void {
    }
}
export class TournamentPlayerList implements ProtocolObject {
    static CLASSID : number =  73;

    classId() {

        return TournamentPlayerList.CLASSID;
    }
    public players : TournamentPlayer[];
    public nrOfRegisteredPlayers : number;

    constructor(players? : TournamentPlayer[], nrOfRegisteredPlayers? : number) {
        this.players = players;
        this.nrOfRegisteredPlayers = nrOfRegisteredPlayers;
    }

    public save(ba : ByteArray) :  void {
        if (!this.players) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.players.length);
            for(let i = 0; i != this.players.length; ++i)
                this.players[i].save(ba);
        }
        ba.writeInt(this.nrOfRegisteredPlayers);
    }

    public load(ba : ByteArray) : void {
        let playersCount : number = ba.readInt();
        this.players = [];
        for(let i = 0; i != playersCount; ++i) {
            let _tmp : TournamentPlayer = new TournamentPlayer();
            _tmp.load(ba);
            this.players.push(_tmp);
        }
        this.nrOfRegisteredPlayers = ba.readInt();
    }
}
export class TournamentPlayer implements ProtocolObject {
    static CLASSID : number =  74;

    classId() {

        return TournamentPlayer.CLASSID;
    }
    public name : string;
    public stackSize : string;
    public position : number;
    public winnings : string;
    public bounty : string;
    public tableId : number;
    public playerId : number;
    public canUnregister : boolean;
    public totalBountyWinnings : string;
    public isEliminated : boolean;

    constructor(name? : string, stackSize? : string, position? : number, winnings? : string, bounty? : string, tableId? : number, playerId? : number, canUnregister? : boolean, totalBountyWinnings? : string, isEliminated? : boolean) {
        this.name = name;
        this.stackSize = stackSize;
        this.position = position;
        this.winnings = winnings;
        this.bounty = bounty;
        this.tableId = tableId;
        this.playerId = playerId;
        this.canUnregister = canUnregister;
        this.totalBountyWinnings = totalBountyWinnings;
        this.isEliminated = isEliminated;
    }

    public save(ba : ByteArray) :  void {
        ba.writeString(this.name);
        ba.writeString(this.stackSize);
        ba.writeInt(this.position);
        ba.writeString(this.winnings);
        ba.writeString(this.bounty);
        ba.writeInt(this.tableId);
        ba.writeInt(this.playerId);
        ba.writeBoolean(this.canUnregister);
        ba.writeString(this.totalBountyWinnings);
        ba.writeBoolean(this.isEliminated);
    }

    public load(ba : ByteArray) : void {
        this.name = ba.readString();
        this.stackSize = ba.readString();
        this.position = ba.readInt();
        this.winnings = ba.readString();
        this.bounty = ba.readString();
        this.tableId = ba.readInt();
        this.playerId = ba.readInt();
        this.canUnregister = ba.readBoolean();
        this.totalBountyWinnings = ba.readString();
        this.isEliminated = ba.readBoolean();
    }
}
export class RequestBlindsStructure implements ProtocolObject {
    static CLASSID : number =  75;

    classId() {

        return RequestBlindsStructure.CLASSID;
    }

    constructor() {
    }

    public save(ba : ByteArray) :  void {
    }

    public load(ba : ByteArray) : void {
    }
}
export class BlindsStructure implements ProtocolObject {
    static CLASSID : number =  76;

    classId() {

        return BlindsStructure.CLASSID;
    }
    public blindsLevels : BlindsLevel[];

    constructor(blindsLevels? : BlindsLevel[]) {
        this.blindsLevels = blindsLevels;
    }

    public save(ba : ByteArray) :  void {
        if (!this.blindsLevels) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.blindsLevels.length);
            for(let i = 0; i != this.blindsLevels.length; ++i)
                this.blindsLevels[i].save(ba);
        }
    }

    public load(ba : ByteArray) : void {
        let blindsLevelsCount : number = ba.readInt();
        this.blindsLevels = [];
        for(let i = 0; i != blindsLevelsCount; ++i) {
            let _tmp : BlindsLevel = new BlindsLevel();
            _tmp.load(ba);
            this.blindsLevels.push(_tmp);
        }
    }
}
export class RequestPayoutInfo implements ProtocolObject {
    static CLASSID : number =  77;

    classId() {

        return RequestPayoutInfo.CLASSID;
    }

    constructor() {
    }

    public save(ba : ByteArray) :  void {
    }

    public load(ba : ByteArray) : void {
    }
}
export class PayoutInfo implements ProtocolObject {
    static CLASSID : number =  78;

    classId() {

        return PayoutInfo.CLASSID;
    }
    public prizePool : string;
    public payouts : Payout[];

    constructor(prizePool? : string, payouts? : Payout[]) {
        this.prizePool = prizePool;
        this.payouts = payouts;
    }

    public save(ba : ByteArray) :  void {
        ba.writeString(this.prizePool);
        if (!this.payouts) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.payouts.length);
            for(let i = 0; i != this.payouts.length; ++i)
                this.payouts[i].save(ba);
        }
    }

    public load(ba : ByteArray) : void {
        this.prizePool = ba.readString();
        let payoutsCount : number = ba.readInt();
        this.payouts = [];
        for(let i = 0; i != payoutsCount; ++i) {
            let _tmp : Payout = new Payout();
            _tmp.load(ba);
            this.payouts.push(_tmp);
        }
    }
}
export class Payout implements ProtocolObject {
    static CLASSID : number =  79;

    classId() {

        return Payout.CLASSID;
    }
    public position : number;
    public payoutAmount : string;
    public ticket : SatelliteTicket;

    constructor(position? : number, payoutAmount? : string, ticket? : SatelliteTicket) {
        this.position = position;
        this.payoutAmount = payoutAmount;
        this.ticket = ticket;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.position);
        ba.writeString(this.payoutAmount);
        this.ticket.save(ba);
    }

    public load(ba : ByteArray) : void {
        this.position = ba.readInt();
        this.payoutAmount = ba.readString();
        this.ticket = new SatelliteTicket();
        this.ticket.load(ba);
    }
}
export class RequestTournamentStatistics implements ProtocolObject {
    static CLASSID : number =  80;

    classId() {

        return RequestTournamentStatistics.CLASSID;
    }

    constructor() {
    }

    public save(ba : ByteArray) :  void {
    }

    public load(ba : ByteArray) : void {
    }
}
export class ChipStatistics implements ProtocolObject {
    static CLASSID : number =  81;

    classId() {

        return ChipStatistics.CLASSID;
    }
    public minStack : string;
    public maxStack : string;
    public averageStack : string;
    public maxBounty : string;

    constructor(minStack? : string, maxStack? : string, averageStack? : string, maxBounty? : string) {
        this.minStack = minStack;
        this.maxStack = maxStack;
        this.averageStack = averageStack;
        this.maxBounty = maxBounty;
    }

    public save(ba : ByteArray) :  void {
        ba.writeString(this.minStack);
        ba.writeString(this.maxStack);
        ba.writeString(this.averageStack);
        ba.writeString(this.maxBounty);
    }

    public load(ba : ByteArray) : void {
        this.minStack = ba.readString();
        this.maxStack = ba.readString();
        this.averageStack = ba.readString();
        this.maxBounty = ba.readString();
    }
}
export class LevelInfo implements ProtocolObject {
    static CLASSID : number =  82;

    classId() {

        return LevelInfo.CLASSID;
    }
    public currentLevel : number;
    public timeToNextLevel : number;

    constructor(currentLevel? : number, timeToNextLevel? : number) {
        this.currentLevel = currentLevel;
        this.timeToNextLevel = timeToNextLevel;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.currentLevel);
        ba.writeInt(this.timeToNextLevel);
    }

    public load(ba : ByteArray) : void {
        this.currentLevel = ba.readInt();
        this.timeToNextLevel = ba.readInt();
    }
}
export class PlayersLeft implements ProtocolObject {
    static CLASSID : number =  83;

    classId() {

        return PlayersLeft.CLASSID;
    }
    public remainingPlayers : number;
    public registeredPlayers : number;

    constructor(remainingPlayers? : number, registeredPlayers? : number) {
        this.remainingPlayers = remainingPlayers;
        this.registeredPlayers = registeredPlayers;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.remainingPlayers);
        ba.writeInt(this.registeredPlayers);
    }

    public load(ba : ByteArray) : void {
        this.remainingPlayers = ba.readInt();
        this.registeredPlayers = ba.readInt();
    }
}
export class FeedbackMessage implements ProtocolObject {
    static CLASSID : number =  84;

    classId() {

        return FeedbackMessage.CLASSID;
    }
    public handId : number;
    public message : string;

    constructor(handId? : number, message? : string) {
        this.handId = handId;
        this.message = message;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.handId);
        ba.writeString(this.message);
    }

    public load(ba : ByteArray) : void {
        this.handId = ba.readInt();
        this.message = ba.readString();
    }
}
export class TournamentStatistics implements ProtocolObject {
    static CLASSID : number =  85;

    classId() {

        return TournamentStatistics.CLASSID;
    }
    public chipStatistics : ChipStatistics;
    public levelInfo : LevelInfo;
    public playersLeft : PlayersLeft;

    constructor(chipStatistics? : ChipStatistics, levelInfo? : LevelInfo, playersLeft? : PlayersLeft) {
        this.chipStatistics = chipStatistics;
        this.levelInfo = levelInfo;
        this.playersLeft = playersLeft;
    }

    public save(ba : ByteArray) :  void {
        this.chipStatistics.save(ba);
        this.levelInfo.save(ba);
        this.playersLeft.save(ba);
    }

    public load(ba : ByteArray) : void {
        this.chipStatistics = new ChipStatistics();
        this.chipStatistics.load(ba);
        this.levelInfo = new LevelInfo();
        this.levelInfo.load(ba);
        this.playersLeft = new PlayersLeft();
        this.playersLeft.load(ba);
    }
}
export class TournamentInfo implements ProtocolObject {
    static CLASSID : number =  86;

    classId() {

        return TournamentInfo.CLASSID;
    }
    public tournamentName : string;
    public gameType : string;
    public variant : Variant = 0;
    public betStrategy : BetStrategy = 0;
    public startTime : string;
    public registrationStartTime : string;
    public buyIn : string;
    public fee : string;
    public bountyFee : string;
    public hasBounty : boolean;
    public mysteryBountyFee : string;
    public hasMysteryBounty : boolean;
    public minPlayers : number;
    public maxPlayers : number;
    public tournamentStatus : TournamentStatus = 0;
    public buyInCurrencyCode : string;
    public description : string;
    public userRuleDescription : string;
    public requiredAchievements : string;
    public rebuysEnabled : boolean;
    public maxRebuys : number;
    public addonEnabled : boolean;
    public lateRegistrationLevel : number;
    public registrationOpen : boolean;
    public historicTournamentId : string;
    public isTargetTournament : boolean;
    public targetTournamentAllowsDirectBuyin : boolean;
    public targetTournamentTickets : SatelliteTicket[];
    public isSatelliteTournament : boolean;
    public satelliteTournamentMustPlayTarget : boolean;
    public satelliteTournamentReturnAmount : string;
    public satelliteTournamentTicket : SatelliteTicket;
    public isDummyTournament : boolean;
    public addonCost : string;
    public addonStack : string;
    public rebuyCost : string;
    public rebuyStack : string;
    public rebuyLevel : string;
    public startStack : string;
    public prizeBoostEnabled : boolean;
    public prizeBoostCash : string;
    public prizeBoostTicket : SatelliteTicket;
    public prizeBoostTicketCount : number;
    public hasPassword : boolean;
    public progressivePercentage : number;
    public attributes : ProtocolAttribute[];
    public reEntryEnabled : boolean;
    public maxReEntries : number;

    constructor(tournamentName? : string, gameType? : string, variant? : Variant, betStrategy? : BetStrategy, startTime? : string, registrationStartTime? : string, buyIn? : string, fee? : string, bountyFee? : string, hasBounty? : boolean, mysteryBountyFee? : string, hasMysteryBounty? : boolean, minPlayers? : number, maxPlayers? : number, tournamentStatus? : TournamentStatus, buyInCurrencyCode? : string, description? : string, userRuleDescription? : string, requiredAchievements? : string, rebuysEnabled? : boolean, maxRebuys? : number, addonEnabled? : boolean, lateRegistrationLevel? : number, registrationOpen? : boolean, historicTournamentId? : string, isTargetTournament? : boolean, targetTournamentAllowsDirectBuyin? : boolean, targetTournamentTickets? : SatelliteTicket[], isSatelliteTournament? : boolean, satelliteTournamentMustPlayTarget? : boolean, satelliteTournamentReturnAmount? : string, satelliteTournamentTicket? : SatelliteTicket, isDummyTournament? : boolean, addonCost? : string, addonStack? : string, rebuyCost? : string, rebuyStack? : string, rebuyLevel? : string, startStack? : string, prizeBoostEnabled? : boolean, prizeBoostCash? : string, prizeBoostTicket? : SatelliteTicket, prizeBoostTicketCount? : number, hasPassword? : boolean, progressivePercentage? : number, attributes? : ProtocolAttribute[], reEntryEnabled? : boolean, maxReEntries? : number) {
        this.tournamentName = tournamentName;
        this.gameType = gameType;
        this.variant = variant;
        this.betStrategy = betStrategy;
        this.startTime = startTime;
        this.registrationStartTime = registrationStartTime;
        this.buyIn = buyIn;
        this.fee = fee;
        this.bountyFee = bountyFee;
        this.hasBounty = hasBounty;
        this.mysteryBountyFee = mysteryBountyFee;
        this.hasMysteryBounty = hasMysteryBounty;
        this.minPlayers = minPlayers;
        this.maxPlayers = maxPlayers;
        this.tournamentStatus = tournamentStatus;
        this.buyInCurrencyCode = buyInCurrencyCode;
        this.description = description;
        this.userRuleDescription = userRuleDescription;
        this.requiredAchievements = requiredAchievements;
        this.rebuysEnabled = rebuysEnabled;
        this.maxRebuys = maxRebuys;
        this.addonEnabled = addonEnabled;
        this.lateRegistrationLevel = lateRegistrationLevel;
        this.registrationOpen = registrationOpen;
        this.historicTournamentId = historicTournamentId;
        this.isTargetTournament = isTargetTournament;
        this.targetTournamentAllowsDirectBuyin = targetTournamentAllowsDirectBuyin;
        this.targetTournamentTickets = targetTournamentTickets;
        this.isSatelliteTournament = isSatelliteTournament;
        this.satelliteTournamentMustPlayTarget = satelliteTournamentMustPlayTarget;
        this.satelliteTournamentReturnAmount = satelliteTournamentReturnAmount;
        this.satelliteTournamentTicket = satelliteTournamentTicket;
        this.isDummyTournament = isDummyTournament;
        this.addonCost = addonCost;
        this.addonStack = addonStack;
        this.rebuyCost = rebuyCost;
        this.rebuyStack = rebuyStack;
        this.rebuyLevel = rebuyLevel;
        this.startStack = startStack;
        this.prizeBoostEnabled = prizeBoostEnabled;
        this.prizeBoostCash = prizeBoostCash;
        this.prizeBoostTicket = prizeBoostTicket;
        this.prizeBoostTicketCount = prizeBoostTicketCount;
        this.hasPassword = hasPassword;
        this.progressivePercentage = progressivePercentage;
        this.attributes = attributes;
        this.reEntryEnabled = reEntryEnabled;
        this.maxReEntries = maxReEntries;
    }

    public save(ba : ByteArray) :  void {
        ba.writeString(this.tournamentName);
        ba.writeString(this.gameType);
        if (typeof(this.variant) == "undefined") {
            ba.writeUnsignedByte(-1);
        } else {
            ba.writeUnsignedByte(this.variant);
        }
        if (typeof(this.betStrategy) == "undefined") {
            ba.writeUnsignedByte(-1);
        } else {
            ba.writeUnsignedByte(this.betStrategy);
        }
        ba.writeString(this.startTime);
        ba.writeString(this.registrationStartTime);
        ba.writeString(this.buyIn);
        ba.writeString(this.fee);
        ba.writeString(this.bountyFee);
        ba.writeBoolean(this.hasBounty);
        ba.writeString(this.mysteryBountyFee);
        ba.writeBoolean(this.hasMysteryBounty);
        ba.writeInt(this.minPlayers);
        ba.writeInt(this.maxPlayers);
        if (typeof(this.tournamentStatus) == "undefined") {
            ba.writeUnsignedByte(-1);
        } else {
            ba.writeUnsignedByte(this.tournamentStatus);
        }
        ba.writeString(this.buyInCurrencyCode);
        ba.writeString(this.description);
        ba.writeString(this.userRuleDescription);
        ba.writeString(this.requiredAchievements);
        ba.writeBoolean(this.rebuysEnabled);
        ba.writeInt(this.maxRebuys);
        ba.writeBoolean(this.addonEnabled);
        ba.writeInt(this.lateRegistrationLevel);
        ba.writeBoolean(this.registrationOpen);
        ba.writeString(this.historicTournamentId);
        ba.writeBoolean(this.isTargetTournament);
        ba.writeBoolean(this.targetTournamentAllowsDirectBuyin);
        if (!this.targetTournamentTickets) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.targetTournamentTickets.length);
            for(let i = 0; i != this.targetTournamentTickets.length; ++i)
                this.targetTournamentTickets[i].save(ba);
        }
        ba.writeBoolean(this.isSatelliteTournament);
        ba.writeBoolean(this.satelliteTournamentMustPlayTarget);
        ba.writeString(this.satelliteTournamentReturnAmount);
        this.satelliteTournamentTicket.save(ba);
        ba.writeBoolean(this.isDummyTournament);
        ba.writeString(this.addonCost);
        ba.writeString(this.addonStack);
        ba.writeString(this.rebuyCost);
        ba.writeString(this.rebuyStack);
        ba.writeString(this.rebuyLevel);
        ba.writeString(this.startStack);
        ba.writeBoolean(this.prizeBoostEnabled);
        ba.writeString(this.prizeBoostCash);
        this.prizeBoostTicket.save(ba);
        ba.writeInt(this.prizeBoostTicketCount);
        ba.writeBoolean(this.hasPassword);
        ba.writeInt(this.progressivePercentage);
        if (!this.attributes) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.attributes.length);
            for(let i = 0; i != this.attributes.length; ++i)
                this.attributes[i].save(ba);
        }
        ba.writeBoolean(this.reEntryEnabled);
        ba.writeInt(this.maxReEntries);
    }

    public load(ba : ByteArray) : void {
        this.tournamentName = ba.readString();
        this.gameType = ba.readString();
        this.variant = ba.readUnsignedByte();
        this.betStrategy = ba.readUnsignedByte();
        this.startTime = ba.readString();
        this.registrationStartTime = ba.readString();
        this.buyIn = ba.readString();
        this.fee = ba.readString();
        this.bountyFee = ba.readString();
        this.hasBounty = ba.readBoolean();
        this.mysteryBountyFee = ba.readString();
        this.hasMysteryBounty = ba.readBoolean();
        this.minPlayers = ba.readInt();
        this.maxPlayers = ba.readInt();
        this.tournamentStatus = ba.readUnsignedByte();
        this.buyInCurrencyCode = ba.readString();
        this.description = ba.readString();
        this.userRuleDescription = ba.readString();
        this.requiredAchievements = ba.readString();
        this.rebuysEnabled = ba.readBoolean();
        this.maxRebuys = ba.readInt();
        this.addonEnabled = ba.readBoolean();
        this.lateRegistrationLevel = ba.readInt();
        this.registrationOpen = ba.readBoolean();
        this.historicTournamentId = ba.readString();
        this.isTargetTournament = ba.readBoolean();
        this.targetTournamentAllowsDirectBuyin = ba.readBoolean();
        let targetTournamentTicketsCount : number = ba.readInt();
        this.targetTournamentTickets = [];
        for(let i = 0; i != targetTournamentTicketsCount; ++i) {
            let _tmp : SatelliteTicket = new SatelliteTicket();
            _tmp.load(ba);
            this.targetTournamentTickets.push(_tmp);
        }
        this.isSatelliteTournament = ba.readBoolean();
        this.satelliteTournamentMustPlayTarget = ba.readBoolean();
        this.satelliteTournamentReturnAmount = ba.readString();
        this.satelliteTournamentTicket = new SatelliteTicket();
        this.satelliteTournamentTicket.load(ba);
        this.isDummyTournament = ba.readBoolean();
        this.addonCost = ba.readString();
        this.addonStack = ba.readString();
        this.rebuyCost = ba.readString();
        this.rebuyStack = ba.readString();
        this.rebuyLevel = ba.readString();
        this.startStack = ba.readString();
        this.prizeBoostEnabled = ba.readBoolean();
        this.prizeBoostCash = ba.readString();
        this.prizeBoostTicket = new SatelliteTicket();
        this.prizeBoostTicket.load(ba);
        this.prizeBoostTicketCount = ba.readInt();
        this.hasPassword = ba.readBoolean();
        this.progressivePercentage = ba.readInt();
        let attributesCount : number = ba.readInt();
        this.attributes = [];
        for(let i = 0; i != attributesCount; ++i) {
            let _tmp : ProtocolAttribute = new ProtocolAttribute();
            _tmp.load(ba);
            this.attributes.push(_tmp);
        }
        this.reEntryEnabled = ba.readBoolean();
        this.maxReEntries = ba.readInt();
    }
}
export class RequestTournamentLobbyData implements ProtocolObject {
    static CLASSID : number =  87;

    classId() {

        return RequestTournamentLobbyData.CLASSID;
    }

    constructor() {
    }

    public save(ba : ByteArray) :  void {
    }

    public load(ba : ByteArray) : void {
    }
}
export class TournamentLobbyData implements ProtocolObject {
    static CLASSID : number =  88;

    classId() {

        return TournamentLobbyData.CLASSID;
    }
    public players : TournamentPlayerList;
    public blindsStructure : BlindsStructure;
    public payoutInfo : PayoutInfo;
    public tournamentStatistics : TournamentStatistics;
    public tournamentInfo : TournamentInfo;
    public tournamentTables : TournamentTables;
    public mysteryBountyPrizeInfo : MysteryBountyPrizeInfo;
    public totalEntries : number;
    public reEnteredPlayers : number;

    constructor(players? : TournamentPlayerList, blindsStructure? : BlindsStructure, payoutInfo? : PayoutInfo, tournamentStatistics? : TournamentStatistics, tournamentInfo? : TournamentInfo, tournamentTables? : TournamentTables, mysteryBountyPrizeInfo? : MysteryBountyPrizeInfo, totalEntries? : number, reEnteredPlayers? : number) {
        this.players = players;
        this.blindsStructure = blindsStructure;
        this.payoutInfo = payoutInfo;
        this.tournamentStatistics = tournamentStatistics;
        this.tournamentInfo = tournamentInfo;
        this.tournamentTables = tournamentTables;
        this.mysteryBountyPrizeInfo = mysteryBountyPrizeInfo;
        this.totalEntries = totalEntries;
        this.reEnteredPlayers = reEnteredPlayers;
    }

    public save(ba : ByteArray) :  void {
        this.players.save(ba);
        this.blindsStructure.save(ba);
        this.payoutInfo.save(ba);
        this.tournamentStatistics.save(ba);
        this.tournamentInfo.save(ba);
        this.tournamentTables.save(ba);
        this.mysteryBountyPrizeInfo.save(ba);
        ba.writeInt(this.totalEntries);
        ba.writeInt(this.reEnteredPlayers);
    }

    public load(ba : ByteArray) : void {
        this.players = new TournamentPlayerList();
        this.players.load(ba);
        this.blindsStructure = new BlindsStructure();
        this.blindsStructure.load(ba);
        this.payoutInfo = new PayoutInfo();
        this.payoutInfo.load(ba);
        this.tournamentStatistics = new TournamentStatistics();
        this.tournamentStatistics.load(ba);
        this.tournamentInfo = new TournamentInfo();
        this.tournamentInfo.load(ba);
        this.tournamentTables = new TournamentTables();
        this.tournamentTables.load(ba);
        this.mysteryBountyPrizeInfo = new MysteryBountyPrizeInfo();
        this.mysteryBountyPrizeInfo.load(ba);
        this.totalEntries = ba.readInt();
        this.reEnteredPlayers = ba.readInt();
    }
}
export class RequestTournamentTable implements ProtocolObject {
    static CLASSID : number =  89;

    classId() {

        return RequestTournamentTable.CLASSID;
    }

    constructor() {
    }

    public save(ba : ByteArray) :  void {
    }

    public load(ba : ByteArray) : void {
    }
}
export class TournamentTable implements ProtocolObject {
    static CLASSID : number =  90;

    classId() {

        return TournamentTable.CLASSID;
    }
    public tableId : number;

    constructor(tableId? : number) {
        this.tableId = tableId;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.tableId);
    }

    public load(ba : ByteArray) : void {
        this.tableId = ba.readInt();
    }
}
export class RebuyOffer implements ProtocolObject {
    static CLASSID : number =  91;

    classId() {

        return RebuyOffer.CLASSID;
    }
    public cost : string;
    public chips : string;
    public timeToAct : number;

    constructor(cost? : string, chips? : string, timeToAct? : number) {
        this.cost = cost;
        this.chips = chips;
        this.timeToAct = timeToAct;
    }

    public save(ba : ByteArray) :  void {
        ba.writeString(this.cost);
        ba.writeString(this.chips);
        ba.writeInt(this.timeToAct);
    }

    public load(ba : ByteArray) : void {
        this.cost = ba.readString();
        this.chips = ba.readString();
        this.timeToAct = ba.readInt();
    }
}
export class RebuyResponse implements ProtocolObject {
    static CLASSID : number =  92;

    classId() {

        return RebuyResponse.CLASSID;
    }
    public answer : boolean;

    constructor(answer? : boolean) {
        this.answer = answer;
    }

    public save(ba : ByteArray) :  void {
        ba.writeBoolean(this.answer);
    }

    public load(ba : ByteArray) : void {
        this.answer = ba.readBoolean();
    }
}
export class AddOnOffer implements ProtocolObject {
    static CLASSID : number =  93;

    classId() {

        return AddOnOffer.CLASSID;
    }
    public cost : string;
    public chips : string;

    constructor(cost? : string, chips? : string) {
        this.cost = cost;
        this.chips = chips;
    }

    public save(ba : ByteArray) :  void {
        ba.writeString(this.cost);
        ba.writeString(this.chips);
    }

    public load(ba : ByteArray) : void {
        this.cost = ba.readString();
        this.chips = ba.readString();
    }
}
export class PerformAddOn implements ProtocolObject {
    static CLASSID : number =  94;

    classId() {

        return PerformAddOn.CLASSID;
    }
    public tableId : number;

    constructor(tableId? : number) {
        this.tableId = tableId;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.tableId);
    }

    public load(ba : ByteArray) : void {
        this.tableId = ba.readInt();
    }
}
export class PlayerPerformedRebuy implements ProtocolObject {
    static CLASSID : number =  95;

    classId() {

        return PlayerPerformedRebuy.CLASSID;
    }

    constructor() {
    }

    public save(ba : ByteArray) :  void {
    }

    public load(ba : ByteArray) : void {
    }
}
export class PlayerPerformedAddOn implements ProtocolObject {
    static CLASSID : number =  96;

    classId() {

        return PlayerPerformedAddOn.CLASSID;
    }

    constructor() {
    }

    public save(ba : ByteArray) :  void {
    }

    public load(ba : ByteArray) : void {
    }
}
export class AddOnPeriodClosed implements ProtocolObject {
    static CLASSID : number =  97;

    classId() {

        return AddOnPeriodClosed.CLASSID;
    }

    constructor() {
    }

    public save(ba : ByteArray) :  void {
    }

    public load(ba : ByteArray) : void {
    }
}
export class TournamentDestroyed implements ProtocolObject {
    static CLASSID : number =  98;

    classId() {

        return TournamentDestroyed.CLASSID;
    }

    constructor() {
    }

    public save(ba : ByteArray) :  void {
    }

    public load(ba : ByteArray) : void {
    }
}
export class RequestTournamentRegistrationInfo implements ProtocolObject {
    static CLASSID : number =  99;

    classId() {

        return RequestTournamentRegistrationInfo.CLASSID;
    }

    constructor() {
    }

    public save(ba : ByteArray) :  void {
    }

    public load(ba : ByteArray) : void {
    }
}
export class TournamentRegistrationInfo implements ProtocolObject {
    static CLASSID : number =  100;

    classId() {

        return TournamentRegistrationInfo.CLASSID;
    }
    public normalBuyIn : TournamentBuyIn;
    public pointsBuyIn : TournamentBuyIn;
    public pointsOnly : boolean;
    public pointsAllowed : boolean;
    public alreadyRegistered : boolean;
    public canUnregister : boolean;
    public ticketAllowed : boolean;
    public ticketRequired : boolean;
    public ticketBuyIns : TicketBuyIn[];
    public hasPassword : boolean;
    public canReEnter : boolean;
    public reEntriesRemaining : number;

    constructor(normalBuyIn? : TournamentBuyIn, pointsBuyIn? : TournamentBuyIn, pointsOnly? : boolean, pointsAllowed? : boolean, alreadyRegistered? : boolean, canUnregister? : boolean, ticketAllowed? : boolean, ticketRequired? : boolean, ticketBuyIns? : TicketBuyIn[], hasPassword? : boolean, canReEnter? : boolean, reEntriesRemaining? : number) {
        this.normalBuyIn = normalBuyIn;
        this.pointsBuyIn = pointsBuyIn;
        this.pointsOnly = pointsOnly;
        this.pointsAllowed = pointsAllowed;
        this.alreadyRegistered = alreadyRegistered;
        this.canUnregister = canUnregister;
        this.ticketAllowed = ticketAllowed;
        this.ticketRequired = ticketRequired;
        this.ticketBuyIns = ticketBuyIns;
        this.hasPassword = hasPassword;
        this.canReEnter = canReEnter;
        this.reEntriesRemaining = reEntriesRemaining;
    }

    public save(ba : ByteArray) :  void {
        this.normalBuyIn.save(ba);
        this.pointsBuyIn.save(ba);
        ba.writeBoolean(this.pointsOnly);
        ba.writeBoolean(this.pointsAllowed);
        ba.writeBoolean(this.alreadyRegistered);
        ba.writeBoolean(this.canUnregister);
        ba.writeBoolean(this.ticketAllowed);
        ba.writeBoolean(this.ticketRequired);
        if (!this.ticketBuyIns) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.ticketBuyIns.length);
            for(let i = 0; i != this.ticketBuyIns.length; ++i)
                this.ticketBuyIns[i].save(ba);
        }
        ba.writeBoolean(this.hasPassword);
        ba.writeBoolean(this.canReEnter);
        ba.writeInt(this.reEntriesRemaining);
    }

    public load(ba : ByteArray) : void {
        this.normalBuyIn = new TournamentBuyIn();
        this.normalBuyIn.load(ba);
        this.pointsBuyIn = new TournamentBuyIn();
        this.pointsBuyIn.load(ba);
        this.pointsOnly = ba.readBoolean();
        this.pointsAllowed = ba.readBoolean();
        this.alreadyRegistered = ba.readBoolean();
        this.canUnregister = ba.readBoolean();
        this.ticketAllowed = ba.readBoolean();
        this.ticketRequired = ba.readBoolean();
        let ticketBuyInsCount : number = ba.readInt();
        this.ticketBuyIns = [];
        for(let i = 0; i != ticketBuyInsCount; ++i) {
            let _tmp : TicketBuyIn = new TicketBuyIn();
            _tmp.load(ba);
            this.ticketBuyIns.push(_tmp);
        }
        this.hasPassword = ba.readBoolean();
        this.canReEnter = ba.readBoolean();
        this.reEntriesRemaining = ba.readInt();
    }
}
export class TournamentBuyIn implements ProtocolObject {
    static CLASSID : number =  102;

    classId() {

        return TournamentBuyIn.CLASSID;
    }
    public buyIn : string;
    public fee : string;
    public bountyFee : string;
    public mysteryBountyFee : string;
    public currency : string;
    public balanceInWallet : string;
    public sufficientFunds : boolean;
    public balanceFailed : boolean;
    public playerAmount : string;
    public playerCurrency : string;

    constructor(buyIn? : string, fee? : string, bountyFee? : string, mysteryBountyFee? : string, currency? : string, balanceInWallet? : string, sufficientFunds? : boolean, balanceFailed? : boolean, playerAmount? : string, playerCurrency? : string) {
        this.buyIn = buyIn;
        this.fee = fee;
        this.bountyFee = bountyFee;
        this.mysteryBountyFee = mysteryBountyFee;
        this.currency = currency;
        this.balanceInWallet = balanceInWallet;
        this.sufficientFunds = sufficientFunds;
        this.balanceFailed = balanceFailed;
        this.playerAmount = playerAmount;
        this.playerCurrency = playerCurrency;
    }

    public save(ba : ByteArray) :  void {
        ba.writeString(this.buyIn);
        ba.writeString(this.fee);
        ba.writeString(this.bountyFee);
        ba.writeString(this.mysteryBountyFee);
        ba.writeString(this.currency);
        ba.writeString(this.balanceInWallet);
        ba.writeBoolean(this.sufficientFunds);
        ba.writeBoolean(this.balanceFailed);
        ba.writeString(this.playerAmount);
        ba.writeString(this.playerCurrency);
    }

    public load(ba : ByteArray) : void {
        this.buyIn = ba.readString();
        this.fee = ba.readString();
        this.bountyFee = ba.readString();
        this.mysteryBountyFee = ba.readString();
        this.currency = ba.readString();
        this.balanceInWallet = ba.readString();
        this.sufficientFunds = ba.readBoolean();
        this.balanceFailed = ba.readBoolean();
        this.playerAmount = ba.readString();
        this.playerCurrency = ba.readString();
    }
}
export class Currency implements ProtocolObject {
    static CLASSID : number =  103;

    classId() {

        return Currency.CLASSID;
    }
    public code : string;
    public fractionalDigits : number;

    constructor(code? : string, fractionalDigits? : number) {
        this.code = code;
        this.fractionalDigits = fractionalDigits;
    }

    public save(ba : ByteArray) :  void {
        ba.writeString(this.code);
        ba.writeInt(this.fractionalDigits);
    }

    public load(ba : ByteArray) : void {
        this.code = ba.readString();
        this.fractionalDigits = ba.readInt();
    }
}
export class AchievementNotificationPacket implements ProtocolObject {
    static CLASSID : number =  104;

    classId() {

        return AchievementNotificationPacket.CLASSID;
    }
    public playerId : number;
    public message : string;

    constructor(playerId? : number, message? : string) {
        this.playerId = playerId;
        this.message = message;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.playerId);
        ba.writeString(this.message);
    }

    public load(ba : ByteArray) : void {
        this.playerId = ba.readInt();
        this.message = ba.readString();
    }
}
export class TournamentTables implements ProtocolObject {
    static CLASSID : number =  105;

    classId() {

        return TournamentTables.CLASSID;
    }
    tables : number[]  = [];

    constructor(tables? : number[]) {
        this.tables = tables;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.tables.length);
        for(let i = 0; i != this.tables.length; ++i) {
            ba.writeInt(this.tables[i]);
        }
    }

    public load(ba : ByteArray) : void {
        let tablesCount : number = ba.readInt();
        this.tables = [];
        for (let i = 0; i < tablesCount; i ++) {
            this.tables.push(ba.readInt());
        }
    }
}
export class Connected implements ProtocolObject {
    static CLASSID : number =  106;

    classId() {

        return Connected.CLASSID;
    }
    public dummy : boolean;

    constructor(dummy? : boolean) {
        this.dummy = dummy;
    }

    public save(ba : ByteArray) :  void {
        ba.writeBoolean(this.dummy);
    }

    public load(ba : ByteArray) : void {
        this.dummy = ba.readBoolean();
    }
}
export class TimeBank implements ProtocolObject {
    static CLASSID : number =  107;

    classId() {

        return TimeBank.CLASSID;
    }
    public maxTime : number;
    public remainingTime : number;

    constructor(maxTime? : number, remainingTime? : number) {
        this.maxTime = maxTime;
        this.remainingTime = remainingTime;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.maxTime);
        ba.writeInt(this.remainingTime);
    }

    public load(ba : ByteArray) : void {
        this.maxTime = ba.readInt();
        this.remainingTime = ba.readInt();
    }
}
export class DisconnectTimeBank implements ProtocolObject {
    static CLASSID : number =  108;

    classId() {

        return DisconnectTimeBank.CLASSID;
    }
    public timeBank : TimeBank;

    constructor(timeBank? : TimeBank) {
        this.timeBank = timeBank;
    }

    public save(ba : ByteArray) :  void {
        this.timeBank.save(ba);
    }

    public load(ba : ByteArray) : void {
        this.timeBank = new TimeBank();
        this.timeBank.load(ba);
    }
}
export class HandWinPercentage implements ProtocolObject {
    static CLASSID : number =  109;

    classId() {

        return HandWinPercentage.CLASSID;
    }
    public dummy : boolean;

    constructor(dummy? : boolean) {
        this.dummy = dummy;
    }

    public save(ba : ByteArray) :  void {
        ba.writeBoolean(this.dummy);
    }

    public load(ba : ByteArray) : void {
        this.dummy = ba.readBoolean();
    }
}
export class PausedStatus implements ProtocolObject {
    static CLASSID : number =  113;

    classId() {

        return PausedStatus.CLASSID;
    }
    public paused : boolean;

    constructor(paused? : boolean) {
        this.paused = paused;
    }

    public save(ba : ByteArray) :  void {
        ba.writeBoolean(this.paused);
    }

    public load(ba : ByteArray) : void {
        this.paused = ba.readBoolean();
    }
}
export class PauseAction implements ProtocolObject {
    static CLASSID : number =  114;

    classId() {

        return PauseAction.CLASSID;
    }
    public pause : boolean;

    constructor(pause? : boolean) {
        this.pause = pause;
    }

    public save(ba : ByteArray) :  void {
        ba.writeBoolean(this.pause);
    }

    public load(ba : ByteArray) : void {
        this.pause = ba.readBoolean();
    }
}
export class RealityCheck implements ProtocolObject {
    static CLASSID : number =  115;

    classId() {

        return RealityCheck.CLASSID;
    }
    public netResult : string;
    public currencyCode : string;
    public duration : number;

    constructor(netResult? : string, currencyCode? : string, duration? : number) {
        this.netResult = netResult;
        this.currencyCode = currencyCode;
        this.duration = duration;
    }

    public save(ba : ByteArray) :  void {
        ba.writeString(this.netResult);
        ba.writeString(this.currencyCode);
        ba.writeInt(this.duration);
    }

    public load(ba : ByteArray) : void {
        this.netResult = ba.readString();
        this.currencyCode = ba.readString();
        this.duration = ba.readInt();
    }
}
export class SatelliteTicket implements ProtocolObject {
    static CLASSID : number =  120;

    classId() {

        return SatelliteTicket.CLASSID;
    }
    public nameId : string;
    public name : string;
    public description : string;
    public imageURL : string;
    public satelliteTournamentInfo : SatelliteTournamentInfo[];
    public targetTournamentInfo : TargetTournamentInfo[];

    constructor(nameId? : string, name? : string, description? : string, imageURL? : string, satelliteTournamentInfo? : SatelliteTournamentInfo[], targetTournamentInfo? : TargetTournamentInfo[]) {
        this.nameId = nameId;
        this.name = name;
        this.description = description;
        this.imageURL = imageURL;
        this.satelliteTournamentInfo = satelliteTournamentInfo;
        this.targetTournamentInfo = targetTournamentInfo;
    }

    public save(ba : ByteArray) :  void {
        ba.writeString(this.nameId);
        ba.writeString(this.name);
        ba.writeString(this.description);
        ba.writeString(this.imageURL);
        if (!this.satelliteTournamentInfo) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.satelliteTournamentInfo.length);
            for(let i = 0; i != this.satelliteTournamentInfo.length; ++i)
                this.satelliteTournamentInfo[i].save(ba);
        }
        if (!this.targetTournamentInfo) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.targetTournamentInfo.length);
            for(let i = 0; i != this.targetTournamentInfo.length; ++i)
                this.targetTournamentInfo[i].save(ba);
        }
    }

    public load(ba : ByteArray) : void {
        this.nameId = ba.readString();
        this.name = ba.readString();
        this.description = ba.readString();
        this.imageURL = ba.readString();
        let satelliteTournamentInfoCount : number = ba.readInt();
        this.satelliteTournamentInfo = [];
        for(let i = 0; i != satelliteTournamentInfoCount; ++i) {
            let _tmp : SatelliteTournamentInfo = new SatelliteTournamentInfo();
            _tmp.load(ba);
            this.satelliteTournamentInfo.push(_tmp);
        }
        let targetTournamentInfoCount : number = ba.readInt();
        this.targetTournamentInfo = [];
        for(let i = 0; i != targetTournamentInfoCount; ++i) {
            let _tmp : TargetTournamentInfo = new TargetTournamentInfo();
            _tmp.load(ba);
            this.targetTournamentInfo.push(_tmp);
        }
    }
}
export class TicketBuyIn implements ProtocolObject {
    static CLASSID : number =  121;

    classId() {

        return TicketBuyIn.CLASSID;
    }
    public ticket : SatelliteTicket;
    public userHaveIt : boolean;

    constructor(ticket? : SatelliteTicket, userHaveIt? : boolean) {
        this.ticket = ticket;
        this.userHaveIt = userHaveIt;
    }

    public save(ba : ByteArray) :  void {
        this.ticket.save(ba);
        ba.writeBoolean(this.userHaveIt);
    }

    public load(ba : ByteArray) : void {
        this.ticket = new SatelliteTicket();
        this.ticket.load(ba);
        this.userHaveIt = ba.readBoolean();
    }
}
export class TargetTournamentInfo implements ProtocolObject {
    static CLASSID : number =  122;

    classId() {

        return TargetTournamentInfo.CLASSID;
    }
    public tournamentId : number;
    public tournamentName : string;
    public tournamentDescription : string;
    public buyIn : string;
    public fee : string;
    public minPlayers : number;
    public maxPlayers : number;
    public buyInCurrencyCode : string;
    public startTime : string;
    public registrationStartTime : string;
    public tournamentStatus : TournamentStatus = 0;

    constructor(tournamentId? : number, tournamentName? : string, tournamentDescription? : string, buyIn? : string, fee? : string, minPlayers? : number, maxPlayers? : number, buyInCurrencyCode? : string, startTime? : string, registrationStartTime? : string, tournamentStatus? : TournamentStatus) {
        this.tournamentId = tournamentId;
        this.tournamentName = tournamentName;
        this.tournamentDescription = tournamentDescription;
        this.buyIn = buyIn;
        this.fee = fee;
        this.minPlayers = minPlayers;
        this.maxPlayers = maxPlayers;
        this.buyInCurrencyCode = buyInCurrencyCode;
        this.startTime = startTime;
        this.registrationStartTime = registrationStartTime;
        this.tournamentStatus = tournamentStatus;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.tournamentId);
        ba.writeString(this.tournamentName);
        ba.writeString(this.tournamentDescription);
        ba.writeString(this.buyIn);
        ba.writeString(this.fee);
        ba.writeInt(this.minPlayers);
        ba.writeInt(this.maxPlayers);
        ba.writeString(this.buyInCurrencyCode);
        ba.writeString(this.startTime);
        ba.writeString(this.registrationStartTime);
        if (typeof(this.tournamentStatus) == "undefined") {
            ba.writeUnsignedByte(-1);
        } else {
            ba.writeUnsignedByte(this.tournamentStatus);
        }
    }

    public load(ba : ByteArray) : void {
        this.tournamentId = ba.readInt();
        this.tournamentName = ba.readString();
        this.tournamentDescription = ba.readString();
        this.buyIn = ba.readString();
        this.fee = ba.readString();
        this.minPlayers = ba.readInt();
        this.maxPlayers = ba.readInt();
        this.buyInCurrencyCode = ba.readString();
        this.startTime = ba.readString();
        this.registrationStartTime = ba.readString();
        this.tournamentStatus = ba.readUnsignedByte();
    }
}
export class SatelliteTournamentInfo implements ProtocolObject {
    static CLASSID : number =  123;

    classId() {

        return SatelliteTournamentInfo.CLASSID;
    }
    public tournamentId : number;
    public tournamentName : string;

    constructor(tournamentId? : number, tournamentName? : string) {
        this.tournamentId = tournamentId;
        this.tournamentName = tournamentName;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.tournamentId);
        ba.writeString(this.tournamentName);
    }

    public load(ba : ByteArray) : void {
        this.tournamentId = ba.readInt();
        this.tournamentName = ba.readString();
    }
}
export class JsngPrizeInfo implements ProtocolObject {
    static CLASSID : number =  125;

    classId() {

        return JsngPrizeInfo.CLASSID;
    }
    public buyIn : string;
    public buyInCurrencyCode : string;
    public prizeList : string[];
    public pickedPrize : string;
    public prizeLevel : number;
    public payoutDistribution : string[];

    constructor(buyIn? : string, buyInCurrencyCode? : string, prizeList? : string[], pickedPrize? : string, prizeLevel? : number, payoutDistribution? : string[]) {
        this.buyIn = buyIn;
        this.buyInCurrencyCode = buyInCurrencyCode;
        this.prizeList = prizeList;
        this.pickedPrize = pickedPrize;
        this.prizeLevel = prizeLevel;
        this.payoutDistribution = payoutDistribution;
    }

    public save(ba : ByteArray) :  void {
        ba.writeString(this.buyIn);
        ba.writeString(this.buyInCurrencyCode);
        if (!this.prizeList) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.prizeList.length);
            for(let i = 0; i != this.prizeList.length; ++i)
                ba.writeString(this.prizeList[i]);
        }
        ba.writeString(this.pickedPrize);
        ba.writeInt(this.prizeLevel);
        if (!this.payoutDistribution) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.payoutDistribution.length);
            for(let i = 0; i != this.payoutDistribution.length; ++i)
                ba.writeString(this.payoutDistribution[i]);
        }
    }

    public load(ba : ByteArray) : void {
        this.buyIn = ba.readString();
        this.buyInCurrencyCode = ba.readString();
        let prizeListCount : number = ba.readInt();
        this.prizeList = [];
        for (let i = 0; i < prizeListCount; i ++) {
            this.prizeList.push(ba.readString());
        }
        this.pickedPrize = ba.readString();
        this.prizeLevel = ba.readInt();
        let payoutDistributionCount : number = ba.readInt();
        this.payoutDistribution = [];
        for (let i = 0; i < payoutDistributionCount; i ++) {
            this.payoutDistribution.push(ba.readString());
        }
    }
}
export class JsngInactivityRequest implements ProtocolObject {
    static CLASSID : number =  126;

    classId() {

        return JsngInactivityRequest.CLASSID;
    }

    constructor() {
    }

    public save(ba : ByteArray) :  void {
    }

    public load(ba : ByteArray) : void {
    }
}
export class JsngInactivityResponse implements ProtocolObject {
    static CLASSID : number =  127;

    classId() {

        return JsngInactivityResponse.CLASSID;
    }
    public continueWaiting : boolean;

    constructor(continueWaiting? : boolean) {
        this.continueWaiting = continueWaiting;
    }

    public save(ba : ByteArray) :  void {
        ba.writeBoolean(this.continueWaiting);
    }

    public load(ba : ByteArray) : void {
        this.continueWaiting = ba.readBoolean();
    }
}
export class TournamentSatelliteTargetListRequest implements ProtocolObject {
    static CLASSID : number =  128;

    classId() {

        return TournamentSatelliteTargetListRequest.CLASSID;
    }

    constructor() {
    }

    public save(ba : ByteArray) :  void {
    }

    public load(ba : ByteArray) : void {
    }
}
export class TemplateInfo implements ProtocolObject {
    static CLASSID : number =  129;

    classId() {

        return TemplateInfo.CLASSID;
    }
    public templateId : number;
    public tournamentName : string;

    constructor(templateId? : number, tournamentName? : string) {
        this.templateId = templateId;
        this.tournamentName = tournamentName;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.templateId);
        ba.writeString(this.tournamentName);
    }

    public load(ba : ByteArray) : void {
        this.templateId = ba.readInt();
        this.tournamentName = ba.readString();
    }
}
export class TournamentSatelliteTargetListResponse implements ProtocolObject {
    static CLASSID : number =  130;

    classId() {

        return TournamentSatelliteTargetListResponse.CLASSID;
    }
    public satellites : TemplateInfo[];
    public targets : TemplateInfo[];

    constructor(satellites? : TemplateInfo[], targets? : TemplateInfo[]) {
        this.satellites = satellites;
        this.targets = targets;
    }

    public save(ba : ByteArray) :  void {
        if (!this.satellites) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.satellites.length);
            for(let i = 0; i != this.satellites.length; ++i)
                this.satellites[i].save(ba);
        }
        if (!this.targets) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.targets.length);
            for(let i = 0; i != this.targets.length; ++i)
                this.targets[i].save(ba);
        }
    }

    public load(ba : ByteArray) : void {
        let satellitesCount : number = ba.readInt();
        this.satellites = [];
        for(let i = 0; i != satellitesCount; ++i) {
            let _tmp : TemplateInfo = new TemplateInfo();
            _tmp.load(ba);
            this.satellites.push(_tmp);
        }
        let targetsCount : number = ba.readInt();
        this.targets = [];
        for(let i = 0; i != targetsCount; ++i) {
            let _tmp : TemplateInfo = new TemplateInfo();
            _tmp.load(ba);
            this.targets.push(_tmp);
        }
    }
}
export class SurgeQuickFold implements ProtocolObject {
    static CLASSID : number =  131;

    classId() {

        return SurgeQuickFold.CLASSID;
    }

    constructor() {
    }

    public save(ba : ByteArray) :  void {
    }

    public load(ba : ByteArray) : void {
    }
}
export class TournamentTableUnregister implements ProtocolObject {
    static CLASSID : number =  132;

    classId() {

        return TournamentTableUnregister.CLASSID;
    }

    constructor() {
    }

    public save(ba : ByteArray) :  void {
    }

    public load(ba : ByteArray) : void {
    }
}
export class TournamentTableUnregisterResponse implements ProtocolObject {
    static CLASSID : number =  133;

    classId() {

        return TournamentTableUnregisterResponse.CLASSID;
    }
    public successful : boolean;

    constructor(successful? : boolean) {
        this.successful = successful;
    }

    public save(ba : ByteArray) :  void {
        ba.writeBoolean(this.successful);
    }

    public load(ba : ByteArray) : void {
        this.successful = ba.readBoolean();
    }
}
export class SitOutTimeLimitExceeded implements ProtocolObject {
    static CLASSID : number =  134;

    classId() {

        return SitOutTimeLimitExceeded.CLASSID;
    }

    constructor() {
    }

    public save(ba : ByteArray) :  void {
    }

    public load(ba : ByteArray) : void {
    }
}
export class TopUpFailedResponse implements ProtocolObject {
    static CLASSID : number =  135;

    classId() {

        return TopUpFailedResponse.CLASSID;
    }

    constructor() {
    }

    public save(ba : ByteArray) :  void {
    }

    public load(ba : ByteArray) : void {
    }
}
export class BountyElimination implements ProtocolObject {
    static CLASSID : number =  136;

    classId() {

        return BountyElimination.CLASSID;
    }
    public eliminatedPlayerId : number;
    public contributors : BountyContributor[];

    constructor(eliminatedPlayerId? : number, contributors? : BountyContributor[]) {
        this.eliminatedPlayerId = eliminatedPlayerId;
        this.contributors = contributors;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.eliminatedPlayerId);
        if (!this.contributors) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.contributors.length);
            for(let i = 0; i != this.contributors.length; ++i)
                this.contributors[i].save(ba);
        }
    }

    public load(ba : ByteArray) : void {
        this.eliminatedPlayerId = ba.readInt();
        let contributorsCount : number = ba.readInt();
        this.contributors = [];
        for(let i = 0; i != contributorsCount; ++i) {
            let _tmp : BountyContributor = new BountyContributor();
            _tmp.load(ba);
            this.contributors.push(_tmp);
        }
    }
}
export class BountyEliminations implements ProtocolObject {
    static CLASSID : number =  137;

    classId() {

        return BountyEliminations.CLASSID;
    }
    public eliminations : BountyElimination[];

    constructor(eliminations? : BountyElimination[]) {
        this.eliminations = eliminations;
    }

    public save(ba : ByteArray) :  void {
        if (!this.eliminations) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.eliminations.length);
            for(let i = 0; i != this.eliminations.length; ++i)
                this.eliminations[i].save(ba);
        }
    }

    public load(ba : ByteArray) : void {
        let eliminationsCount : number = ba.readInt();
        this.eliminations = [];
        for(let i = 0; i != eliminationsCount; ++i) {
            let _tmp : BountyElimination = new BountyElimination();
            _tmp.load(ba);
            this.eliminations.push(_tmp);
        }
    }
}
export class BountyContributor implements ProtocolObject {
    static CLASSID : number =  138;

    classId() {

        return BountyContributor.CLASSID;
    }
    public bountyShare : string;
    public contributorId : number;

    constructor(bountyShare? : string, contributorId? : number) {
        this.bountyShare = bountyShare;
        this.contributorId = contributorId;
    }

    public save(ba : ByteArray) :  void {
        ba.writeString(this.bountyShare);
        ba.writeInt(this.contributorId);
    }

    public load(ba : ByteArray) : void {
        this.bountyShare = ba.readString();
        this.contributorId = ba.readInt();
    }
}
export class PlayerBounty implements ProtocolObject {
    static CLASSID : number =  139;

    classId() {

        return PlayerBounty.CLASSID;
    }
    public playerId : number;
    public bountyAmount : string;
    public rank : number;

    constructor(playerId? : number, bountyAmount? : string, rank? : number) {
        this.playerId = playerId;
        this.bountyAmount = bountyAmount;
        this.rank = rank;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.playerId);
        ba.writeString(this.bountyAmount);
        ba.writeInt(this.rank);
    }

    public load(ba : ByteArray) : void {
        this.playerId = ba.readInt();
        this.bountyAmount = ba.readString();
        this.rank = ba.readInt();
    }
}
export class CloseTableWindow implements ProtocolObject {
    static CLASSID : number =  142;

    classId() {

        return CloseTableWindow.CLASSID;
    }
    public closeTableReason : CloseTableReason = 0;

    constructor(closeTableReason? : CloseTableReason) {
        this.closeTableReason = closeTableReason;
    }

    public save(ba : ByteArray) :  void {
        if (typeof(this.closeTableReason) == "undefined") {
            ba.writeUnsignedByte(-1);
        } else {
            ba.writeUnsignedByte(this.closeTableReason);
        }
    }

    public load(ba : ByteArray) : void {
        this.closeTableReason = ba.readUnsignedByte();
    }
}
export class SurgePoolShutdown implements ProtocolObject {
    static CLASSID : number =  143;

    classId() {

        return SurgePoolShutdown.CLASSID;
    }

    constructor() {
    }

    public save(ba : ByteArray) :  void {
    }

    public load(ba : ByteArray) : void {
    }
}
export class BestLowHand implements ProtocolObject {
    static CLASSID : number =  144;

    classId() {

        return BestLowHand.CLASSID;
    }
    public player : number;
    public cards : GameCard[];
    public handId : number;

    constructor(player? : number, cards? : GameCard[], handId? : number) {
        this.player = player;
        this.cards = cards;
        this.handId = handId;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.player);
        if (!this.cards) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.cards.length);
            for(let i = 0; i != this.cards.length; ++i)
                this.cards[i].save(ba);
        }
        ba.writeInt(this.handId);
    }

    public load(ba : ByteArray) : void {
        this.player = ba.readInt();
        let cardsCount : number = ba.readInt();
        this.cards = [];
        for(let i = 0; i != cardsCount; ++i) {
            let _tmp : GameCard = new GameCard();
            _tmp.load(ba);
            this.cards.push(_tmp);
        }
        this.handId = ba.readInt();
    }
}
export class PotShare implements ProtocolObject {
    static CLASSID : number =  145;

    classId() {

        return PotShare.CLASSID;
    }
    public potId : number;
    public playerId : number;
    public amount : string;
    public type : string;

    constructor(potId? : number, playerId? : number, amount? : string, type? : string) {
        this.potId = potId;
        this.playerId = playerId;
        this.amount = amount;
        this.type = type;
    }

    public save(ba : ByteArray) :  void {
        ba.writeByte(this.potId);
        ba.writeInt(this.playerId);
        ba.writeString(this.amount);
        ba.writeString(this.type);
    }

    public load(ba : ByteArray) : void {
        this.potId = ba.readByte();
        this.playerId = ba.readInt();
        this.amount = ba.readString();
        this.type = ba.readString();
    }
}
export class TimedTournamentInfo implements ProtocolObject {
    static CLASSID : number =  146;

    classId() {

        return TimedTournamentInfo.CLASSID;
    }
    public endTimeUtc : string;

    constructor(endTimeUtc? : string) {
        this.endTimeUtc = endTimeUtc;
    }

    public save(ba : ByteArray) :  void {
        ba.writeString(this.endTimeUtc);
    }

    public load(ba : ByteArray) : void {
        this.endTimeUtc = ba.readString();
    }
}
export class BonusPotEvent implements ProtocolObject {
    static CLASSID : number =  147;

    classId() {

        return BonusPotEvent.CLASSID;
    }
    public bonusAmount : string;

    constructor(bonusAmount? : string) {
        this.bonusAmount = bonusAmount;
    }

    public save(ba : ByteArray) :  void {
        ba.writeString(this.bonusAmount);
    }

    public load(ba : ByteArray) : void {
        this.bonusAmount = ba.readString();
    }
}
export class MysteryBountyPrizeInfo implements ProtocolObject {
    static CLASSID : number =  148;

    classId() {

        return MysteryBountyPrizeInfo.CLASSID;
    }
    public structureType : PrizeStructureType = 0;
    public prizePool : string;
    public prizes : Prize[];
    public eliminationsUntilInTheBounty : number;

    constructor(structureType? : PrizeStructureType, prizePool? : string, prizes? : Prize[], eliminationsUntilInTheBounty? : number) {
        this.structureType = structureType;
        this.prizePool = prizePool;
        this.prizes = prizes;
        this.eliminationsUntilInTheBounty = eliminationsUntilInTheBounty;
    }

    public save(ba : ByteArray) :  void {
        if (typeof(this.structureType) == "undefined") {
            ba.writeUnsignedByte(-1);
        } else {
            ba.writeUnsignedByte(this.structureType);
        }
        ba.writeString(this.prizePool);
        if (!this.prizes) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.prizes.length);
            for(let i = 0; i != this.prizes.length; ++i)
                this.prizes[i].save(ba);
        }
        ba.writeInt(this.eliminationsUntilInTheBounty);
    }

    public load(ba : ByteArray) : void {
        this.structureType = ba.readUnsignedByte();
        this.prizePool = ba.readString();
        let prizesCount : number = ba.readInt();
        this.prizes = [];
        for(let i = 0; i != prizesCount; ++i) {
            let _tmp : Prize = new Prize();
            _tmp.load(ba);
            this.prizes.push(_tmp);
        }
        this.eliminationsUntilInTheBounty = ba.readInt();
    }
}
export class Prize implements ProtocolObject {
    static CLASSID : number =  149;

    classId() {

        return Prize.CLASSID;
    }
    public position : number;
    public amount : string;
    public isClaimed : boolean;
    claimedPlayerIds : number[]  = [];

    constructor(position? : number, amount? : string, isClaimed? : boolean, claimedPlayerIds? : number[]) {
        this.position = position;
        this.amount = amount;
        this.isClaimed = isClaimed;
        this.claimedPlayerIds = claimedPlayerIds;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.position);
        ba.writeString(this.amount);
        ba.writeBoolean(this.isClaimed);
        ba.writeInt(this.claimedPlayerIds.length);
        for(let i = 0; i != this.claimedPlayerIds.length; ++i) {
            ba.writeInt(this.claimedPlayerIds[i]);
        }
    }

    public load(ba : ByteArray) : void {
        this.position = ba.readInt();
        this.amount = ba.readString();
        this.isClaimed = ba.readBoolean();
        let claimedPlayerIdsCount : number = ba.readInt();
        this.claimedPlayerIds = [];
        for (let i = 0; i < claimedPlayerIdsCount; i ++) {
            this.claimedPlayerIds.push(ba.readInt());
        }
    }
}
export class InTheBounty implements ProtocolObject {
    static CLASSID : number =  150;

    classId() {

        return InTheBounty.CLASSID;
    }

    constructor() {
    }

    public save(ba : ByteArray) :  void {
    }

    public load(ba : ByteArray) : void {
    }
}
export class MysteryBountyState implements ProtocolObject {
    static CLASSID : number =  151;

    classId() {

        return MysteryBountyState.CLASSID;
    }
    public inTheBounty : boolean;

    constructor(inTheBounty? : boolean) {
        this.inTheBounty = inTheBounty;
    }

    public save(ba : ByteArray) :  void {
        ba.writeBoolean(this.inTheBounty);
    }

    public load(ba : ByteArray) : void {
        this.inTheBounty = ba.readBoolean();
    }
}
export enum Suit { CLUBS, DIAMONDS, HEARTS, SPADES, HIDDEN, JOKER };

export enum Rank { TWO, THREE, FOUR, FIVE, SIX, SEVEN, EIGHT, NINE, TEN, JACK, QUEEN, KING, ACE, HIDDEN, JOKER };

export enum HandType { UNKNOWN, HIGH_CARD, PAIR, TWO_PAIR, THREE_OF_A_KIND, STRAIGHT, FLUSH, FULL_HOUSE, FOUR_OF_A_KIND, STRAIGHT_FLUSH, ROYAL_STRAIGHT_FLUSH, FIVE_OF_A_KIND };

export enum HandPhaseHoldem { PREFLOP, FLOP, TURN, RIVER };

export enum HandPhase5card { BETTING, THIRD_STREET, FOURTH_STREET, FIFTH_STREET };

export enum ActionType { SMALL_BLIND, BIG_BLIND, CALL, CHECK, BET, RAISE, FOLD, DECLINE_ENTRY_BET, ANTE, BIG_BLIND_PLUS_DEAD_SMALL_BLIND, DEAD_SMALL_BLIND, ENTRY_BET, WAIT_FOR_BIG_BLIND, DISCARD, BRING_IN, SHOW_CARDS, MUCK_CARDS, TIME_BANK, HIT, STAND, DOUBLE, SPLIT, SHOW_REMAINING_CARDS, PASS, PLAY_CARD, EXPOSE_CARD, CONTINUE_HAND, ANTE_PLUS_SMALL_BLIND, ANTE_PLUS_BIG_BLIND, ANTE_PLUS_ENTRY_BET, ANTE_PLUS_BIG_BLIND_PLUS_DEAD_SMALL_BLIND, ANTE_PLUS_DEAD_SMALL_BLIND, POSITION_CARDS, ALL_IN };

export enum PotType { MAIN, SIDE };

export enum PlayerTableStatus { SITIN, SITOUT };

export enum BuyInResultCode { OK, PENDING, INSUFFICIENT_FUNDS_ERROR, PARTNER_ERROR, MAX_LIMIT_REACHED, AMOUNT_TOO_HIGH, UNSPECIFIED_ERROR, SESSION_NOT_OPEN, USER_LIMIT_EXCEEDED, INVALID_TICKET };

export enum BuyInInfoResultCode { OK, MAX_LIMIT_REACHED, UNSPECIFIED_ERROR };

export enum ErrorCode { UNSPECIFIED_ERROR, TABLE_CLOSING, TABLE_CLOSING_FORCED, CLOSED_SESSION_DUE_TO_FATAL_ERROR };

export enum CardPosition { TOP, MIDDLE, BOTTOM, FOLDED };

export enum SystemMessageCode { NA, JSNG_DISABLED, JSNG_GAME_LIMIT_EXCEEDED, RG_PLAYER_TIMEOUT_REACHED, RG_TIME_LIMIT_REACHED, SERVER_ERROR };

export enum Variant { TEXAS_HOLDEM, TELESINA, CRAZY_PINEAPPLE, FIVE_CARD_STUD, SEVEN_CARD_STUD, OMAHA, OMAHA_HL };

export enum BetStrategy { FIXED_LIMIT, NO_LIMIT, POT_LIMIT };

export enum TournamentStatus { ANNOUNCED, REGISTERING, FINISH_REGISTRATION, PREPARING_START, RUNNING, ON_BREAK, PREPARING_BREAK, FINISHED, CANCELLED, CLOSED, FAILED, DUMMY_CONCLUDED, ERROR_CLOSED };

export enum CloseTableReason { SURGE_LEAVE, SURGE_INACTIVITY };

export enum PrizeStructureType { PERCENTAGE };

export class ProtocolObjectFactory implements ObjectFactory {

    public  version() : number {
        return 1;
    }

    public create(classId : number, ba : ByteArray)  : ProtocolObject {
        var obj = this.createClass(classId);
        obj.load(ba);
        return obj;
    }

    public createClass(classId:number) : ProtocolObject {
        switch(classId) {
            case 1:
                return new PlayerAction();
            case 4:
                return new ErrorPacket();
            case 5:
                return new FuturePlayerAction();
            case 6:
                return new GameState();
            case 7:
                return new ProtocolAttribute();
            case 8:
                return new GameCard();
            case 9:
                return new BestHand();
            case 10:
                return new BestHandAttribute();
            case 11:
                return new PlayerState();
            case 12:
                return new CardToDeal();
            case 13:
                return new RequestAction();
            case 14:
                return new CardMoved();
            case 15:
                return new InformFutureAllowedActions();
            case 16:
                return new HandStartInfo();
            case 17:
                return new DealerButton();
            case 18:
                return new StartDealPocketCards();
            case 19:
                return new StopDealPocketCards();
            case 20:
                return new DealPublicCards();
            case 21:
                return new RedealCommunityCards();
            case 22:
                return new DealPrivateCards();
            case 23:
                return new ExposePrivateCards();
            case 24:
                return new HandEnd();
            case 25:
                return new HandCanceled();
            case 26:
                return new ClearTable();
            case 27:
                return new StartHandHistory();
            case 28:
                return new StopHandHistory();
            case 29:
                return new PerformAction();
            case 33:
                return new ChessClock();
            case 35:
                return new HandStartsIn();
            case 37:
                return new CardAction();
            case 38:
                return new PositionCardsAction();
            case 40:
                return new PlayerBetStack();
            case 41:
                return new BetStackChanged();
            case 42:
                return new CardChanged();
            case 43:
                return new TournamentOut();
            case 44:
                return new PlayerBalance();
            case 45:
                return new BuyInInfoRequest();
            case 46:
                return new BuyInInfoResponse();
            case 47:
                return new BuyInRequest();
            case 48:
                return new BuyInCancel();
            case 49:
                return new BuyInResponse();
            case 50:
                return new TournamentBuyInResponse();
            case 51:
                return new Pot();
            case 52:
                return new PotTransfer();
            case 53:
                return new PotTransfers();
            case 54:
                return new TakeBackUncalledBet();
            case 56:
                return new PlayerPokerStatus();
            case 57:
                return new PlayerHandStartStatus();
            case 58:
                return new PlayerSitinRequest();
            case 59:
                return new PlayerSitoutRequest();
            case 60:
                return new RoundInfoUpdate();
            case 61:
                return new TournamentPositionUpdate();
            case 62:
                return new DeckInfo();
            case 63:
                return new ExternalSessionInfoPacket();
            case 64:
                return new PlayerDisconnectedPacket();
            case 65:
                return new PlayerReconnectedPacket();
            case 66:
                return new PingPacket();
            case 67:
                return new PongPacket();
            case 68:
                return new WaitingToStartBreak();
            case 69:
                return new WaitingForPlayers();
            case 70:
                return new BlindsAreUpdated();
            case 71:
                return new BlindsLevel();
            case 72:
                return new RequestTournamentPlayerList();
            case 73:
                return new TournamentPlayerList();
            case 74:
                return new TournamentPlayer();
            case 75:
                return new RequestBlindsStructure();
            case 76:
                return new BlindsStructure();
            case 77:
                return new RequestPayoutInfo();
            case 78:
                return new PayoutInfo();
            case 79:
                return new Payout();
            case 80:
                return new RequestTournamentStatistics();
            case 81:
                return new ChipStatistics();
            case 82:
                return new LevelInfo();
            case 83:
                return new PlayersLeft();
            case 84:
                return new FeedbackMessage();
            case 85:
                return new TournamentStatistics();
            case 86:
                return new TournamentInfo();
            case 87:
                return new RequestTournamentLobbyData();
            case 88:
                return new TournamentLobbyData();
            case 89:
                return new RequestTournamentTable();
            case 90:
                return new TournamentTable();
            case 91:
                return new RebuyOffer();
            case 92:
                return new RebuyResponse();
            case 93:
                return new AddOnOffer();
            case 94:
                return new PerformAddOn();
            case 95:
                return new PlayerPerformedRebuy();
            case 96:
                return new PlayerPerformedAddOn();
            case 97:
                return new AddOnPeriodClosed();
            case 98:
                return new TournamentDestroyed();
            case 99:
                return new RequestTournamentRegistrationInfo();
            case 100:
                return new TournamentRegistrationInfo();
            case 102:
                return new TournamentBuyIn();
            case 103:
                return new Currency();
            case 104:
                return new AchievementNotificationPacket();
            case 105:
                return new TournamentTables();
            case 106:
                return new Connected();
            case 107:
                return new TimeBank();
            case 108:
                return new DisconnectTimeBank();
            case 109:
                return new HandWinPercentage();
            case 113:
                return new PausedStatus();
            case 114:
                return new PauseAction();
            case 115:
                return new RealityCheck();
            case 120:
                return new SatelliteTicket();
            case 121:
                return new TicketBuyIn();
            case 122:
                return new TargetTournamentInfo();
            case 123:
                return new SatelliteTournamentInfo();
            case 125:
                return new JsngPrizeInfo();
            case 126:
                return new JsngInactivityRequest();
            case 127:
                return new JsngInactivityResponse();
            case 128:
                return new TournamentSatelliteTargetListRequest();
            case 129:
                return new TemplateInfo();
            case 130:
                return new TournamentSatelliteTargetListResponse();
            case 131:
                return new SurgeQuickFold();
            case 132:
                return new TournamentTableUnregister();
            case 133:
                return new TournamentTableUnregisterResponse();
            case 134:
                return new SitOutTimeLimitExceeded();
            case 135:
                return new TopUpFailedResponse();
            case 136:
                return new BountyElimination();
            case 137:
                return new BountyEliminations();
            case 138:
                return new BountyContributor();
            case 139:
                return new PlayerBounty();
            case 142:
                return new CloseTableWindow();
            case 143:
                return new SurgePoolShutdown();
            case 144:
                return new BestLowHand();
            case 145:
                return new PotShare();
            case 146:
                return new TimedTournamentInfo();
            case 147:
                return new BonusPotEvent();
            case 148:
                return new MysteryBountyPrizeInfo();
            case 149:
                return new Prize();
            case 150:
                return new InTheBounty();
            case 151:
                return new MysteryBountyState();
        }
        throw new Error("Unknown class id: " + classId);
    }
}

